var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSienna(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 20,
    viewBox: "0 0 53 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44264 16.4101L5.23014 15.8851L7.59262 16.1476L12.5801 16.2789L12.8426 16.5414H13.7613L13.8926 15.3601C13.8926 15.3601 13.4988 12.9977 13.3676 12.7352C13.2363 12.4727 11.7926 10.6352 9.03636 10.5039C6.28013 10.3727 4.57389 12.4727 4.3114 13.6539C4.0489 14.9664 4.31139 16.2789 4.44264 16.4101Z",
    fill: "#232020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6602 15.2273C11.6602 14.0461 10.6102 12.9961 9.42892 12.9961C8.24767 12.9961 7.19768 14.0461 7.19768 15.2273C7.19768 16.4086 8.24767 17.4586 9.42892 17.4586C10.6102 17.4586 11.6602 16.4086 11.6602 15.2273Z",
    fill: "url(#paint0_linear_9942_107848)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9727 15.2285C12.9727 17.3285 11.2664 19.166 9.03518 19.166C6.9352 19.166 5.09771 17.4597 5.09771 15.2285C5.09771 13.1285 6.80395 11.291 9.03518 11.291C11.1352 11.291 12.9727 13.1285 12.9727 15.2285ZM11.5289 15.0972C11.5289 13.916 10.4789 12.866 9.29768 12.866C8.11644 12.866 7.06645 13.916 7.06645 15.0972C7.06645 16.2785 8.11644 17.3285 9.29768 17.3285C10.4789 17.3285 11.5289 16.4097 11.5289 15.0972Z",
    fill: "url(#paint1_linear_9942_107848)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1348 15.0976C11.1348 16.1476 10.216 17.0664 9.16602 17.0664C8.11603 17.0664 7.19728 16.1476 7.19728 15.0976C7.19728 14.0476 8.11603 13.1289 9.16602 13.1289C10.3473 13.1289 11.1348 14.0476 11.1348 15.0976ZM7.45978 15.4914C7.45978 15.3601 7.32853 15.3601 7.45978 15.4914C7.32853 15.3601 7.32853 15.3601 7.45978 15.4914C7.32853 15.4914 7.32853 15.4914 7.45978 15.4914C7.32853 15.4914 7.45978 15.4914 7.45978 15.4914ZM7.59104 14.8351C7.59104 14.7039 7.59104 14.7039 7.59104 14.8351C7.59104 14.7039 7.45979 14.7039 7.59104 14.8351C7.45979 14.8351 7.59104 14.8351 7.59104 14.8351ZM7.98478 15.7539C7.98478 15.7539 7.85353 15.6226 7.98478 15.7539C7.85353 15.6226 7.85353 15.7539 7.98478 15.7539C7.85353 15.7539 7.85353 15.7539 7.98478 15.7539C7.85353 15.7539 7.98478 15.7539 7.98478 15.7539ZM7.98478 14.0476C7.98478 13.9164 7.98478 14.0476 7.98478 14.0476C7.98478 13.9164 7.98478 14.0476 7.98478 14.0476ZM8.11603 13.6539C8.11603 13.6539 7.98478 13.6539 8.11603 13.6539C7.98478 13.6539 7.98478 13.6539 8.11603 13.6539C7.98478 13.7851 7.98478 13.7851 8.11603 13.6539C7.98478 13.7851 8.11603 13.7851 8.11603 13.6539ZM8.90353 16.8039C8.77228 16.8039 8.77228 16.8039 8.90353 16.8039C8.77228 16.8039 8.77228 16.8039 8.90353 16.8039ZM9.16602 16.5414C9.16602 16.5414 9.03478 16.5414 9.16602 16.5414C9.03478 16.5414 9.03478 16.5414 9.16602 16.5414C9.03478 16.6726 9.03478 16.5414 9.16602 16.5414C9.03478 16.6726 9.16602 16.5414 9.16602 16.5414ZM10.4785 16.0164C10.4785 15.8851 10.4785 16.0164 10.4785 16.0164C10.3473 15.8851 10.3473 16.0164 10.4785 16.0164C10.3473 16.0164 10.3473 16.0164 10.4785 16.0164ZM10.8723 15.4914C10.8723 15.4914 10.8723 15.6226 10.8723 15.4914C10.8723 15.4914 10.8723 15.6226 10.8723 15.4914Z",
    fill: "#808081"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6113 15.0976C10.6113 15.8851 9.95508 16.4101 9.29884 16.4101C8.51134 16.4101 7.98634 15.7539 7.98634 15.0976C7.98634 14.3102 8.64259 13.7852 9.29884 13.7852C9.95508 13.7852 10.6113 14.3102 10.6113 15.0976Z",
    fill: "#59595B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6602 15.361C11.6602 16.936 10.3477 18.1172 8.90393 18.1172C7.32894 18.1172 6.1477 16.8047 6.1477 15.361C6.1477 13.786 7.46019 12.6048 8.90393 12.6048C10.4789 12.4735 11.6602 13.786 11.6602 15.361ZM11.2664 15.2297C11.2664 14.0485 10.2164 12.9985 9.03518 12.9985C7.85394 12.9985 6.80395 14.0485 6.80395 15.2297C6.80395 16.411 7.85394 17.461 9.03518 17.461C10.2164 17.461 11.2664 16.5422 11.2664 15.2297Z",
    fill: "url(#paint2_linear_9942_107848)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6602 15.3596C11.6602 16.8033 10.4789 17.9845 9.03518 17.9845C7.59144 17.9845 6.4102 16.8033 6.4102 15.3596C6.4102 13.9158 7.59144 12.7346 9.03518 12.7346C10.4789 12.6033 11.6602 13.7846 11.6602 15.3596ZM11.2664 15.2283C11.2664 14.0471 10.3477 13.1283 9.16643 13.1283C7.98519 13.1283 7.06645 14.0471 7.06645 15.2283C7.06645 16.4095 7.98519 17.3283 9.16643 17.3283C10.2164 17.4595 11.2664 16.4095 11.2664 15.2283Z",
    fill: "url(#paint3_linear_9942_107848)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3965 15.3586C11.3965 16.6711 10.3465 17.7211 9.03401 17.7211C7.72152 17.7211 6.67153 16.6711 6.67153 15.3586C6.67153 14.0461 7.72152 12.9961 9.03401 12.9961C10.3465 12.9961 11.3965 14.0461 11.3965 15.3586ZM11.2652 15.2273C11.2652 14.0461 10.3465 13.1273 9.16525 13.1273C7.98401 13.1273 7.06527 14.0461 7.06527 15.2273C7.06527 16.4086 7.98401 17.3273 9.16525 17.3273C10.2152 17.4586 11.2652 16.4086 11.2652 15.2273Z",
    fill: "url(#paint4_linear_9942_107848)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6602 15.3596C11.6602 16.8033 10.4789 17.9845 9.03518 17.9845C7.59144 17.9845 6.4102 16.8033 6.4102 15.3596C6.4102 13.9158 7.59144 12.7346 9.03518 12.7346C10.3477 12.6033 11.6602 13.7846 11.6602 15.3596ZM11.3977 15.2283C11.3977 13.9158 10.3477 12.7346 8.90393 12.7346C7.59144 12.7346 6.4102 13.7846 6.4102 15.2283C6.4102 16.5408 7.4602 17.722 8.90393 17.722C10.3477 17.722 11.3977 16.5408 11.3977 15.2283Z",
    fill: "url(#paint5_linear_9942_107848)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77151 12.8676L8.90276 13.1301C8.90276 13.1301 8.77151 13.7863 9.03401 13.7863C9.16525 13.7863 9.16525 13.6551 9.16525 13.6551L9.559 12.7363L9.69025 13.1301C9.69025 13.1301 9.559 14.3113 9.559 14.4426C9.95275 14.3113 10.609 14.0488 10.7402 13.9176H11.134V14.4426C11.134 14.4426 10.084 14.7051 10.2152 14.8363C10.3465 15.0988 11.2652 15.0988 11.3965 15.0988L11.2652 15.2301C11.2652 15.2301 10.084 15.4926 9.95275 15.6238C9.8215 15.6238 9.95275 15.7551 10.084 16.0176C10.2152 16.1488 10.609 16.6738 10.609 16.6738L10.7402 17.0676L9.69025 16.4113C9.69025 16.5426 9.69025 16.8051 9.95275 16.9363C10.084 17.0675 10.084 17.0676 10.084 17.0676L10.2152 17.33V17.5925C10.2152 17.5925 9.03401 16.2801 8.90276 16.2801C8.77151 16.4113 8.37776 17.0675 8.24651 17.33C8.11527 17.5925 7.85276 17.7238 7.85276 17.7238L8.11526 16.4113C8.11526 16.4113 7.98401 16.4113 7.85276 16.5426C7.72151 16.6738 7.45902 17.0676 7.45902 17.0676L7.19652 17.1988L6.80277 17.0676V16.9363C6.80277 16.9363 7.72151 15.7551 7.85276 15.6238C7.85276 15.4926 7.85277 15.4926 7.72152 15.4926C7.72152 15.4926 6.80278 15.2301 6.67153 15.2301C6.54028 15.2301 6.14653 15.0988 6.14653 15.0988L6.40903 14.7051H6.67153C6.67153 14.7051 7.32777 14.9676 7.45902 14.8363C7.59027 14.7051 6.67152 14.4426 6.54027 14.4426C6.40903 14.4426 6.54027 13.9176 6.54027 13.9176C6.54027 13.9176 6.93402 13.9176 7.06527 13.9176C7.19652 13.9176 8.11527 14.4426 8.24651 14.4426C8.64026 14.3113 8.77151 12.8676 8.77151 12.8676Z",
    fill: "#232020"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24612 12.7352C8.24612 12.7352 8.37736 14.0476 8.37736 14.1789C8.37736 14.4414 8.24611 14.4414 8.11486 14.4414C8.11486 14.4414 7.58987 14.3101 6.67113 13.9164L6.53987 14.1789L6.67113 14.3101C6.67113 14.3101 7.58987 14.5726 7.58987 14.7039C7.58987 14.7039 7.58987 14.8351 7.45862 14.8351C7.32737 14.8351 6.67112 14.5726 6.53987 14.5726C6.40863 14.5726 6.40863 14.7039 6.27738 14.7039C6.27738 14.7039 6.27738 14.9664 6.27738 15.0976C6.27738 15.0976 6.80237 15.2289 7.19612 15.3601C7.58987 15.3601 7.85237 15.4914 7.85237 15.6226C7.85237 15.7539 7.85237 15.8851 7.45862 16.2789C7.06487 16.6726 6.80237 16.9351 6.80237 17.0664C6.80237 17.1976 7.06487 17.3289 7.06487 17.3289C7.06487 17.3289 7.06487 17.3289 7.32737 17.3289C7.32737 17.3289 7.85237 16.4101 8.11486 16.5414C8.24611 16.6726 8.11486 16.6726 8.11486 16.8039C7.98362 16.9351 7.58987 17.4601 7.58987 17.4601V17.7226L7.85237 17.8539C7.85237 17.8539 8.63986 16.4101 8.77111 16.4101C8.90236 16.4101 8.90236 16.4101 9.16486 16.9351C9.68985 17.3289 9.95235 17.8539 9.95235 17.8539C10.0836 17.8539 10.2149 17.7226 10.2149 17.7226V17.4601C10.2149 17.4601 9.55861 16.6726 9.68985 16.5414C9.68985 16.5414 9.68985 16.5414 9.8211 16.6726C9.95235 16.8039 10.3461 17.3289 10.3461 17.3289H10.6086C10.6086 17.3289 10.8711 17.1976 10.8711 17.0664C10.8711 17.0664 9.95235 16.0164 9.95235 15.8851C9.95235 15.7539 9.82111 15.6226 10.2149 15.4914C10.4774 15.4914 11.5273 15.2289 11.5273 15.2289C11.5273 15.2289 11.5273 14.9664 11.5273 14.8351L11.2648 14.7039C11.2648 14.7039 10.3461 15.0976 10.2149 14.8351C10.2149 14.5726 11.0023 14.4414 11.1336 14.4414L11.2648 14.1789L11.1336 13.9164L9.68985 14.4414C9.55861 14.4414 9.42736 14.3101 9.42736 14.1789C9.42736 14.0476 9.42736 12.7352 9.55861 12.7352L9.29611 12.6039L9.16486 12.7352C9.16486 12.7352 9.29611 13.7851 9.03361 13.7851C8.90236 13.7851 8.77111 13.5226 8.90236 12.7352L8.77111 12.4727C8.63986 12.6039 8.37737 12.6039 8.24612 12.7352Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19751 17.3277C7.19751 17.3277 7.85376 16.409 8.11626 16.2777C8.37876 16.1465 8.64126 16.0152 8.51001 16.409C8.37876 16.8027 8.51001 16.6715 8.11626 17.1965L7.72251 17.7215V17.459C7.72251 17.459 7.98501 17.0652 8.11626 16.8027C8.11626 16.8027 8.24751 16.5402 8.11626 16.5402C7.98501 16.5402 7.85376 16.6715 7.72251 16.8027C7.59126 16.934 7.32877 17.3277 7.32877 17.3277H7.19751Z",
    fill: "url(#paint6_linear_9942_107848)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27619 14.7027C6.27619 14.7027 7.19493 15.0965 7.71992 15.0965C7.71992 15.0965 7.85117 15.0965 7.98242 14.9652C7.98242 14.834 7.85117 14.7027 7.71992 14.7027C7.71992 14.7027 6.53868 14.1777 6.40744 14.1777L6.53868 14.4402C6.53868 14.4402 7.32618 14.7027 7.45742 14.834C7.45742 14.834 7.58867 14.834 7.45742 14.9652C7.45742 15.0965 7.32618 14.9652 7.06368 14.9652C6.93243 14.9652 6.40744 14.834 6.27619 14.7027C6.40744 14.7027 6.53869 14.5715 6.27619 14.7027Z",
    fill: "url(#paint7_linear_9942_107848)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63868 12.6035C8.63868 12.6035 8.63867 13.7848 8.76992 13.916C8.90117 14.1785 8.90117 14.3098 9.03242 14.1785C9.16367 14.1785 9.29492 13.916 9.29492 13.6535C9.29492 13.391 9.29492 12.6035 9.29492 12.6035L9.16367 12.7348C9.16367 12.7348 9.16367 13.5223 9.16367 13.6535C9.16367 13.7848 9.16367 13.7848 9.03242 13.7848C9.03242 13.7848 8.90118 13.7848 8.90118 13.5223C8.90118 13.2598 8.90118 12.9973 8.90118 12.7348L8.63868 12.6035Z",
    fill: "url(#paint8_linear_9942_107848)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3961 14.1777C11.3961 14.1777 10.3461 14.5715 10.0836 14.7027C9.95235 14.834 9.8211 15.0965 10.3461 15.0965C10.8711 15.0965 11.5273 14.834 11.5273 14.834L11.2648 14.7027C11.2648 14.7027 10.6086 14.9652 10.4773 14.9652C10.3461 14.9652 10.2149 14.9652 10.3461 14.7027C10.6086 14.5715 11.1336 14.4402 11.1336 14.4402L11.3961 14.1777Z",
    fill: "url(#paint9_linear_9942_107848)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55899 16.1462C9.42774 16.1462 9.42774 16.4087 9.55899 16.6712C9.69024 16.9337 10.2152 17.59 10.2152 17.59V17.3275C10.2152 17.3275 9.55899 16.54 9.69024 16.4087C9.69024 16.4087 9.82149 16.4087 10.084 16.6712C10.3465 17.065 10.4777 17.1962 10.4777 17.1962H10.7402C10.7402 17.1962 10.084 16.2775 9.82149 16.1462C9.82149 16.1462 9.69024 16.015 9.55899 16.1462Z",
    fill: "url(#paint10_linear_9942_107848)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50977 14.5723C8.50977 14.5723 8.37852 14.441 8.24727 14.441C8.11602 14.441 6.80352 13.916 6.80352 13.916L6.67227 14.1785C6.67227 14.1785 7.98477 14.5723 8.11602 14.8348C8.24727 14.966 8.24727 15.0973 8.37852 15.0973C8.24727 15.0973 8.50977 14.5723 8.50977 14.5723Z",
    fill: "url(#paint11_linear_9942_107848)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9847 15.0988C7.9847 15.0988 7.7222 15.0988 7.59095 15.0988C7.4597 15.0988 6.9347 14.9676 6.1472 14.7051V15.0988C6.1472 15.0988 6.6722 15.2301 7.59095 15.4926L7.85345 15.6238C7.98469 15.6238 8.11595 15.3613 7.9847 15.0988Z",
    fill: "url(#paint12_linear_9942_107848)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98477 15.6209C7.98477 15.6209 7.98477 15.7521 7.72227 16.0146C7.45977 16.2771 6.93478 16.9334 6.93478 17.0646C6.93478 17.0646 7.06603 17.3271 7.19727 17.3271C7.19727 17.3271 7.85352 16.2771 8.24727 16.1459C8.37852 16.1459 8.50977 16.1459 8.50977 16.1459C8.37852 16.1459 8.24727 15.4896 7.98477 15.6209Z",
    fill: "url(#paint13_linear_9942_107848)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59051 17.59C7.59051 17.59 8.24675 16.6712 8.24675 16.54C8.24675 16.4087 8.378 16.1462 8.378 16.1462C8.378 16.015 8.77175 16.1462 8.77175 16.1462C8.90299 16.2775 8.77175 16.2775 8.77175 16.2775L8.50925 16.54L7.853 17.59C7.853 17.59 7.59051 17.7212 7.59051 17.59Z",
    fill: "url(#paint14_linear_9942_107848)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0336 16.2783C9.0336 16.4095 9.16485 16.4095 9.2961 16.672C9.5586 17.0658 9.5586 17.3283 9.82109 17.5908L9.95234 17.8533L10.2148 17.722C10.2148 17.722 9.16485 16.5408 9.5586 16.2783C9.5586 16.147 9.16485 15.8845 9.0336 16.2783Z",
    fill: "url(#paint15_linear_9942_107848)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56016 16.0164C9.56016 16.0164 9.69141 16.0164 9.82266 16.1477C9.82266 16.1477 10.2164 16.5414 10.7414 17.1976C10.7414 17.1976 11.0039 17.0664 11.0039 16.9351C11.0039 16.9351 10.2164 15.8852 10.0852 15.7539C9.95391 15.7539 9.69141 16.0164 9.56016 16.0164Z",
    fill: "url(#paint16_linear_9942_107848)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95261 14.9652C9.95261 14.9652 10.0839 15.0965 10.3464 15.0965C10.7401 15.0965 11.3964 14.834 11.5276 14.834C11.5276 14.834 11.6589 15.0965 11.5276 15.2277C11.5276 15.2277 11.0026 15.359 10.0839 15.6215C10.0839 15.6215 9.82136 15.359 9.95261 14.9652Z",
    fill: "url(#paint17_linear_9942_107848)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2648 13.916C11.2648 13.916 10.2148 14.3098 9.8211 14.441C9.8211 14.441 9.68985 14.441 9.68985 14.3098C9.68985 14.1785 9.8211 14.8348 10.0836 14.8348C10.0836 14.8348 10.0836 14.7035 10.2149 14.5723C10.3461 14.441 11.3961 14.0473 11.5273 14.0473C11.3961 14.1785 11.2648 13.916 11.2648 13.916Z",
    fill: "url(#paint18_linear_9942_107848)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2961 12.6035C9.2961 12.6035 9.2961 13.6535 9.2961 13.7848C9.2961 13.916 9.2961 14.1785 9.0336 14.1785C9.0336 14.1785 9.2961 14.441 9.55859 14.3098C9.55859 14.1785 9.55859 14.1785 9.55859 14.0473C9.55859 13.916 9.55859 12.7348 9.55859 12.7348L9.2961 12.6035Z",
    fill: "url(#paint19_linear_9942_107848)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24632 12.7348C8.24632 12.7348 8.50881 12.6035 8.64006 12.6035C8.64006 12.866 8.64006 13.391 8.7713 13.7848C8.7713 13.7848 8.90255 14.1785 9.0338 14.1785C9.16505 14.1785 8.64006 14.3098 8.50881 14.3098C8.37756 14.3098 8.24632 12.866 8.24632 12.7348Z",
    fill: "url(#paint20_linear_9942_107848)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95117 15.2273C9.95117 15.7523 9.55742 16.1461 9.03243 16.1461C8.50743 16.1461 8.11368 15.7523 8.11368 15.2273C8.11368 14.7023 8.50743 14.3086 9.03243 14.3086C9.55742 14.3086 9.95117 14.7023 9.95117 15.2273Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82031 15.2273C9.82031 15.7523 9.42657 16.1461 8.90158 16.1461C8.37658 16.1461 7.98283 15.7523 7.98283 15.2273C7.98283 14.7023 8.37658 14.3086 8.90158 14.3086C9.42657 14.3086 9.82031 14.7023 9.82031 15.2273Z",
    fill: "#FAFAFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82031 15.2269C9.82031 15.6207 9.42657 16.0144 9.03282 16.0144C8.63907 16.0144 8.24533 15.6207 8.24533 15.2269C8.24533 14.8332 8.63907 14.4395 9.03282 14.4395C9.42657 14.4395 9.82031 14.7019 9.82031 15.2269Z",
    fill: "#F4F4F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 15.2269C9.6875 15.6207 9.425 16.0144 9.03125 16.0144C8.63751 16.0144 8.24376 15.7519 8.24376 15.3582C8.24376 14.9644 8.50626 14.5707 8.90001 14.5707C9.29375 14.4394 9.6875 14.8332 9.6875 15.2269Z",
    fill: "#EFEFF0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 15.2285C9.6875 15.6223 9.425 15.8848 9.03125 15.8848C8.63751 15.8848 8.37501 15.6223 8.37501 15.2285C8.37501 14.8348 8.63751 14.5723 9.03125 14.5723C9.29375 14.5723 9.55625 14.8348 9.6875 15.2285Z",
    fill: "#E9EAEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55859 15.2271C9.55859 15.4896 9.29609 15.8834 9.03359 15.8834C8.7711 15.8834 8.37735 15.6209 8.37735 15.3584C8.37735 15.0959 8.63985 14.7021 8.90235 14.7021C9.2961 14.5709 9.55859 14.8334 9.55859 15.2271Z",
    fill: "#E4E4E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55859 15.2262C9.55859 15.4887 9.42734 15.7512 9.16484 15.7512C8.90235 15.7512 8.63985 15.6199 8.63985 15.3574C8.63985 15.0949 8.7711 14.8324 9.0336 14.8324C9.16485 14.7012 9.42735 14.8324 9.55859 15.2262Z",
    fill: "#DFDFE1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42773 15.0949C9.42773 15.3574 9.29649 15.6199 9.03399 15.6199C8.7715 15.6199 8.509 15.4887 8.509 15.2262C8.509 14.9637 8.64025 14.7012 8.90275 14.7012C9.16524 14.7012 9.42773 14.9637 9.42773 15.0949Z",
    fill: "#D9DADC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29492 15.0945C9.29492 15.357 9.16367 15.4883 9.03242 15.4883C8.76992 15.4883 8.63868 15.357 8.63868 15.2258C8.63868 14.9633 8.76993 14.832 8.90118 14.832C9.16367 14.832 9.29492 14.9633 9.29492 15.0945Z",
    fill: "#D4D5D7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29492 15.0945C9.29492 15.2258 9.29492 15.4883 9.03242 15.4883C8.90117 15.4883 8.63868 15.4883 8.63868 15.2258C8.63868 15.0945 8.63868 14.832 8.90118 14.832C9.03242 14.832 9.16367 14.9633 9.29492 15.0945Z",
    fill: "#CFCFD2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 15.0961C9.16406 15.2273 9.16406 15.3586 9.03281 15.3586C8.90156 15.3586 8.77031 15.3586 8.77031 15.2273C8.77031 15.0961 8.77031 14.9648 8.90156 14.9648C9.03282 14.9648 9.16406 14.9648 9.16406 15.0961Z",
    fill: "#C9CACD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 15.0954C9.16406 15.2267 9.16406 15.3579 9.16406 15.3579C9.03281 15.3579 8.90156 15.3579 8.90156 15.3579C8.90156 15.2267 8.90156 15.0954 8.90156 15.0954C8.90156 14.9642 9.03281 15.0954 9.16406 15.0954Z",
    fill: "#C4C5C8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03242 15.0957C9.16367 15.0957 9.16367 15.2269 9.03242 15.3582C9.03242 15.4894 8.90118 15.4894 8.76993 15.3582C8.63868 15.3582 8.63868 15.227 8.76993 15.0957C8.90118 15.0957 9.03242 15.0957 9.03242 15.0957Z",
    fill: "#BEBFC3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 15.2273C9.16406 15.3586 9.16406 15.3586 9.16406 15.2273C8.90156 15.3586 8.90156 15.3586 8.90156 15.2273C8.90156 15.0961 8.90156 15.0961 9.16406 15.2273Z",
    fill: "#B9BABE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69141 15.2285C9.69141 15.6223 9.42891 15.8848 9.03516 15.8848C8.64141 15.8848 8.37892 15.6223 8.37892 15.2285C8.37892 14.8348 8.64141 14.5723 9.03516 14.5723C9.42891 14.5723 9.69141 14.8348 9.69141 15.2285Z",
    fill: "url(#paint21_linear_9942_107848)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11641 15.2273C8.24766 15.3586 8.11641 15.3586 8.11641 15.2273C8.37891 15.3586 8.37891 15.2273 8.37891 15.2273C8.37891 15.0961 8.24766 15.0961 8.11641 15.2273C8.11641 15.0961 8.24766 15.0961 8.11641 15.2273Z",
    fill: "url(#paint22_linear_9942_107848)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24727 15.2273C8.37852 15.3586 8.24727 15.3586 8.24727 15.2273C8.50977 15.3586 8.50977 15.2273 8.50977 15.2273C8.50977 15.0961 8.37852 15.0961 8.24727 15.2273C8.24727 15.2273 8.24727 15.0961 8.24727 15.2273Z",
    fill: "#232020"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37891 15.0977V15.2289V15.3601H8.24766V15.2289L8.37891 15.0977Z",
    fill: "url(#paint23_linear_9942_107848)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24726 15.2283C8.24726 15.3595 8.24726 15.3595 8.24726 15.2283C8.37852 15.2283 8.37852 15.3595 8.24726 15.2283C8.37852 15.2283 8.37852 15.097 8.24726 15.2283C8.24726 15.2283 8.24726 15.097 8.24726 15.2283Z",
    fill: "#232020"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24726 15.2285C8.24726 15.3598 8.24726 15.3598 8.24726 15.2285C8.37852 15.2285 8.37852 15.3598 8.24726 15.2285C8.37852 15.2285 8.37852 15.2285 8.24726 15.2285Z",
    fill: "url(#paint24_linear_9942_107848)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37891 15.3602C8.37891 15.3602 8.24766 15.2289 8.37891 15.3602C8.24766 15.2289 8.24766 15.2289 8.37891 15.3602Z",
    fill: "url(#paint25_linear_9942_107848)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90351 14.5711C9.03477 14.7023 8.90351 14.7023 8.90351 14.5711C9.16602 14.7023 9.16602 14.5711 9.16602 14.5711C9.16602 14.4398 9.03477 14.4398 8.90351 14.5711C8.90351 14.5711 8.90351 14.4398 8.90351 14.5711Z",
    fill: "url(#paint26_linear_9942_107848)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90351 14.5711C9.03477 14.7023 8.90351 14.7023 8.90351 14.5711C9.16602 14.7023 9.16602 14.5711 9.16602 14.5711C9.16602 14.4398 9.03477 14.4398 8.90351 14.5711C8.90351 14.5711 8.90351 14.4398 8.90351 14.5711Z",
    fill: "#232020"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03476 14.4414L9.16602 14.5727V14.7039H9.03476H8.90351V14.5727L9.03476 14.4414Z",
    fill: "url(#paint27_linear_9942_107848)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90313 14.5723C8.90313 14.7035 8.90313 14.7035 8.90313 14.5723C9.03438 14.5723 9.03438 14.7035 8.90313 14.5723C9.03438 14.5723 9.16564 14.5723 8.90313 14.5723Z",
    fill: "#232020"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90352 14.5723C8.90352 14.7035 8.90352 14.7035 8.90352 14.5723C9.03476 14.5723 9.03476 14.7035 8.90352 14.5723C9.03476 14.5723 9.03476 14.5723 8.90352 14.5723Z",
    fill: "url(#paint28_linear_9942_107848)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03516 14.7039C9.03516 14.5727 9.03516 14.7039 9.03516 14.7039C8.9039 14.5727 8.9039 14.5727 9.03516 14.7039Z",
    fill: "url(#paint29_linear_9942_107848)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42891 15.3605C9.56016 15.4918 9.42891 15.4918 9.42891 15.3605C9.69141 15.4918 9.69141 15.3605 9.69141 15.3605C9.69141 15.2293 9.56016 15.2293 9.42891 15.3605C9.42891 15.2293 9.56016 15.098 9.42891 15.3605Z",
    fill: "url(#paint30_linear_9942_107848)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55979 15.3605C9.69103 15.4918 9.55979 15.4918 9.55979 15.3605C9.82227 15.4918 9.82227 15.3605 9.82227 15.3605C9.82227 15.2293 9.69103 15.2293 9.55979 15.3605C9.55979 15.2293 9.55979 15.098 9.55979 15.3605Z",
    fill: "#232020"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69103 15.2285H9.82227V15.3598L9.69103 15.491L9.55979 15.3598V15.2285H9.69103Z",
    fill: "url(#paint31_linear_9942_107848)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55976 15.3602C9.69102 15.3602 9.69102 15.4914 9.55976 15.3602C9.69102 15.2289 9.69102 15.2289 9.55976 15.3602C9.55976 15.2289 9.55976 15.2289 9.55976 15.3602Z",
    fill: "#232020"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55976 15.3602C9.69102 15.3602 9.69102 15.4914 9.55976 15.3602C9.69102 15.2289 9.69102 15.2289 9.55976 15.3602C9.55976 15.2289 9.55976 15.2289 9.55976 15.3602Z",
    fill: "url(#paint32_linear_9942_107848)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69141 15.3602C9.69141 15.2289 9.69141 15.3602 9.69141 15.3602C9.69141 15.2289 9.56017 15.2289 9.69141 15.3602Z",
    fill: "url(#paint33_linear_9942_107848)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90351 15.8836C9.03477 16.0148 8.90351 16.0148 8.90351 15.8836C9.16602 16.0148 9.16602 15.8836 9.16602 15.8836C9.16602 15.7523 9.03477 15.7523 8.90351 15.8836C8.90351 15.8836 8.90351 15.7523 8.90351 15.8836Z",
    fill: "url(#paint34_linear_9942_107848)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90351 15.8836C9.03477 16.0148 8.90351 16.0148 8.90351 15.8836C9.16602 16.0148 9.16602 15.8836 9.16602 15.8836C9.16602 15.7523 9.03477 15.7523 8.90351 15.8836C8.90351 15.8836 8.90351 15.7523 8.90351 15.8836Z",
    fill: "#232020"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03476 15.7539L9.16602 15.8852V16.0164H9.03476H8.90351V15.8852L9.03476 15.7539Z",
    fill: "url(#paint35_linear_9942_107848)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90313 15.8848C8.90313 16.016 8.90313 16.016 8.90313 15.8848C9.03438 15.8848 9.03438 16.016 8.90313 15.8848C9.03438 15.8848 9.16564 15.8848 8.90313 15.8848Z",
    fill: "#232020"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90352 15.8848C8.90352 16.016 8.90352 16.016 8.90352 15.8848C9.03476 15.8848 9.03476 16.016 8.90352 15.8848C9.03476 15.8848 9.03476 15.8848 8.90352 15.8848Z",
    fill: "url(#paint36_linear_9942_107848)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03516 16.0164C9.03516 15.8852 9.03516 16.0164 9.03516 16.0164C8.9039 15.8852 8.9039 15.8852 9.03516 16.0164Z",
    fill: "url(#paint37_linear_9942_107848)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29883 15.2277C9.29883 15.4902 9.16758 15.6215 8.90508 15.6215C8.64258 15.6215 8.51133 15.4902 8.51133 15.2277C8.51133 14.9652 8.64258 14.834 8.90508 14.834C9.16758 14.834 9.29883 15.0965 9.29883 15.2277Z",
    fill: "#F4F4F4"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22815 15.2285C5.22815 15.2285 5.22815 13.2598 6.80314 12.0786C8.37813 10.8973 10.2156 11.6848 10.3469 11.8161C10.4781 11.9473 8.64064 10.7661 6.9344 12.2098C5.09691 13.6536 5.22815 15.2285 5.22815 15.2285Z",
    fill: "#47413E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5168 16.8053H39.0918L46.4417 16.6741L47.098 17.1991L47.3605 16.8053C47.3605 16.8053 48.0167 11.1616 42.7668 10.8991C37.5168 10.7678 37.2543 15.6241 37.5168 16.8053Z",
    fill: "#232020"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15.491C45 14.3098 43.95 13.2598 42.7688 13.2598C41.5875 13.2598 40.5375 14.3098 40.5375 15.491C40.5375 16.6722 41.5875 17.7222 42.7688 17.7222C43.95 17.7222 45 16.6722 45 15.491Z",
    fill: "url(#paint38_linear_9942_107848)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3125 15.4922C46.3125 17.5921 44.6063 19.4296 42.375 19.4296C40.1438 19.4296 38.4376 17.7234 38.4376 15.4922C38.4376 13.3922 40.1438 11.5547 42.375 11.5547C44.6063 11.5547 46.3125 13.3922 46.3125 15.4922ZM44.8688 15.3609C44.8688 14.1797 43.8188 13.1297 42.6375 13.1297C41.4563 13.1297 40.4063 14.1797 40.4063 15.3609C40.4063 16.5421 41.4563 17.5921 42.6375 17.5921C43.8188 17.5921 44.8688 16.6734 44.8688 15.3609Z",
    fill: "url(#paint39_linear_9942_107848)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4746 15.3613C44.4746 16.4113 43.5559 17.3301 42.5059 17.3301C41.4559 17.3301 40.5371 16.4113 40.5371 15.3613C40.5371 14.3113 41.4559 13.3926 42.5059 13.3926C43.6871 13.3926 44.4746 14.3113 44.4746 15.3613ZM40.7996 15.7551C40.7996 15.6238 40.7996 15.6238 40.7996 15.7551C40.6684 15.6238 40.6684 15.6238 40.7996 15.7551C40.6684 15.7551 40.6684 15.7551 40.7996 15.7551ZM40.9309 15.0988C40.9309 14.9676 40.9309 14.9676 40.9309 15.0988C40.9309 14.9676 40.7996 14.9676 40.9309 15.0988C40.7996 15.0988 40.9309 15.0988 40.9309 15.0988ZM41.3246 16.0176C41.3246 16.0176 41.1934 16.0176 41.3246 16.0176C41.1934 16.0176 41.1934 16.0176 41.3246 16.0176C41.1934 16.0176 41.1934 16.0176 41.3246 16.0176C41.1934 16.0176 41.3246 16.0176 41.3246 16.0176ZM41.3246 14.3113C41.3246 14.1801 41.3246 14.3113 41.3246 14.3113C41.3246 14.1801 41.3246 14.3113 41.3246 14.3113ZM41.4559 13.9176C41.4559 13.9176 41.3246 13.9176 41.4559 13.9176C41.3246 13.9176 41.3246 13.9176 41.4559 13.9176C41.3246 14.0488 41.3246 14.0488 41.4559 13.9176C41.3246 14.0488 41.4559 14.0488 41.4559 13.9176ZM42.2434 17.0676C42.1121 17.0676 42.1121 17.0676 42.2434 17.0676C42.1121 17.0676 42.1121 17.0676 42.2434 17.0676ZM42.5059 16.8051C42.5059 16.8051 42.3746 16.8051 42.5059 16.8051C42.3746 16.8051 42.3746 16.8051 42.5059 16.8051C42.3746 16.9363 42.3746 16.8051 42.5059 16.8051C42.3746 16.9363 42.5059 16.8051 42.5059 16.8051ZM43.8184 16.2801C43.6871 16.2801 43.6871 16.2801 43.8184 16.2801C43.6871 16.2801 43.6871 16.2801 43.8184 16.2801ZM44.2121 15.7551C44.2121 15.7551 44.2121 15.8863 44.2121 15.7551C44.2121 15.7551 44.2121 15.8863 44.2121 15.7551Z",
    fill: "#808081"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9512 15.3613C43.9512 16.1488 43.2949 16.6738 42.6387 16.6738C41.8512 16.6738 41.3262 16.0176 41.3262 15.3613C41.3262 14.5738 41.9824 14.0488 42.6387 14.0488C43.2949 14.0488 43.9512 14.7051 43.9512 15.3613Z",
    fill: "#59595B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1309 15.6247C45.1309 17.1997 43.8184 18.3809 42.3746 18.3809C40.7996 18.3809 39.6184 17.0684 39.6184 15.6247C39.6184 14.0497 40.9309 12.8684 42.3746 12.8684C43.8184 12.7372 45.1309 14.0497 45.1309 15.6247ZM44.6059 15.4934C44.6059 14.3122 43.5559 13.2622 42.3746 13.2622C41.1934 13.2622 40.1434 14.3122 40.1434 15.4934C40.1434 16.6747 41.1934 17.7247 42.3746 17.7247C43.5559 17.7247 44.6059 16.8059 44.6059 15.4934Z",
    fill: "url(#paint40_linear_9942_107848)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15.6232C45 17.067 43.8188 18.2482 42.375 18.2482C40.9313 18.2482 39.75 17.067 39.75 15.6232C39.75 14.1795 40.9313 12.9982 42.375 12.9982C43.8188 12.867 45 14.0482 45 15.6232ZM44.6063 15.492C44.6063 14.3107 43.6875 13.392 42.5063 13.392C41.325 13.392 40.4063 14.3107 40.4063 15.492C40.4063 16.6732 41.325 17.592 42.5063 17.592C43.5563 17.7232 44.6063 16.6732 44.6063 15.492Z",
    fill: "url(#paint41_linear_9942_107848)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7383 15.6222C44.7383 16.9347 43.6883 17.9847 42.3758 17.9847C41.0633 17.9847 40.0133 16.9347 40.0133 15.6222C40.0133 14.3098 41.0633 13.2598 42.3758 13.2598C43.6883 13.2598 44.7383 14.3098 44.7383 15.6222ZM44.607 15.491C44.607 14.3098 43.6883 13.391 42.507 13.391C41.3258 13.391 40.4071 14.3098 40.4071 15.491C40.4071 16.6722 41.3258 17.591 42.507 17.591C43.557 17.7222 44.607 16.6722 44.607 15.491Z",
    fill: "url(#paint42_linear_9942_107848)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15.6232C45 17.067 43.8188 18.2482 42.375 18.2482C40.9313 18.2482 39.75 17.067 39.75 15.6232C39.75 14.1795 40.9313 12.9982 42.375 12.9982C43.6875 12.867 45 14.0482 45 15.6232ZM44.7375 15.492C44.7375 14.1795 43.6875 12.9982 42.2438 12.9982C40.9313 12.9982 39.75 14.0482 39.75 15.492C39.75 16.8045 40.8 17.9857 42.2438 17.9857C43.6875 17.9857 44.7375 16.8045 44.7375 15.492Z",
    fill: "url(#paint43_linear_9942_107848)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2445 13.1313L42.3758 13.2625V13.3937C42.3758 13.3937 42.2445 14.05 42.507 14.05V13.9187L42.9008 13L43.032 13.3937C43.032 13.3937 42.9008 14.575 42.9008 14.7062C43.2945 14.575 43.9508 14.3125 44.082 14.1812H44.4758V14.7062C44.4758 14.7062 43.4258 14.9687 43.557 15.1C43.6883 15.3625 44.607 15.3625 44.7383 15.3625H44.607C44.607 15.3625 43.4258 15.625 43.2945 15.7562C43.1633 15.7562 43.2945 15.8875 43.4258 16.15C43.557 16.2812 43.9508 16.8062 43.9508 16.8062L44.082 17.2L43.032 16.5437C43.032 16.675 43.032 16.9375 43.2945 17.0687C43.4258 17.2 43.4258 17.2 43.4258 17.2L43.557 17.4625V17.725C43.557 17.725 42.3758 16.4125 42.2445 16.4125C42.1133 16.5437 41.7196 17.2 41.5883 17.4625C41.4571 17.725 41.1946 17.8562 41.1946 17.8562L41.4571 16.5437C41.4571 16.5437 41.3258 16.5437 41.1946 16.675C41.0633 16.8062 40.8008 17.2 40.8008 17.2L40.5383 17.3312L40.1446 17.2V17.0687C40.1446 17.0687 41.0633 15.8875 41.1946 15.7562C41.1946 15.625 41.1946 15.625 41.0633 15.625C41.0633 15.625 40.1446 15.3625 40.0133 15.3625C39.8821 15.3625 39.4883 15.2312 39.4883 15.2312L39.8821 14.9687H40.1446C40.1446 14.9687 40.8008 15.2312 40.9321 15.1C41.0633 14.9687 40.1446 14.7062 40.0133 14.7062C39.8821 14.7062 40.0133 14.1812 40.0133 14.1812C40.0133 14.1812 40.4071 14.1812 40.5383 14.1812C40.6696 14.1812 41.5883 14.7062 41.7196 14.7062C41.982 14.575 42.2445 13.1313 42.2445 13.1313Z",
    fill: "#232020"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5871 12.9988C41.5871 12.9988 41.7184 14.3113 41.7184 14.4426C41.7184 14.7051 41.5871 14.7051 41.4559 14.7051C41.4559 14.7051 40.9309 14.5738 39.8809 14.1801L39.7496 14.4426L39.8809 14.5738C39.8809 14.5738 40.7996 14.8363 40.7996 14.9676C40.7996 14.9676 40.7996 15.0988 40.6684 15.0988C40.5371 15.0988 39.8809 14.8363 39.7496 14.8363C39.6184 14.8363 39.6184 14.9676 39.4871 14.9676C39.4871 14.9676 39.4871 15.2301 39.4871 15.3613C39.4871 15.3613 40.0121 15.4926 40.4059 15.6238C40.7996 15.6238 41.0621 15.7551 41.0621 15.8863C41.0621 16.0176 41.0621 16.1488 40.6684 16.5426C40.2746 16.9363 40.0121 17.1988 40.0121 17.33C40.0121 17.4613 40.2746 17.5925 40.2746 17.5925C40.2746 17.5925 40.2746 17.5925 40.5371 17.5925C40.5371 17.5925 41.0621 16.6738 41.3246 16.8051C41.4559 16.9363 41.3246 16.9363 41.3246 17.0676C41.1934 17.1988 40.7996 17.7238 40.7996 17.7238V17.9863L41.0621 18.1175C41.0621 18.1175 41.8496 16.6738 41.9809 16.6738C42.1121 16.6738 42.1121 16.6738 42.3746 17.1988C42.6371 17.7238 42.8996 18.1175 42.8996 18.1175C43.0309 18.1175 43.1621 17.9863 43.1621 17.9863V17.7238C43.1621 17.7238 42.5059 16.9363 42.6371 16.8051C42.6371 16.8051 42.6371 16.8051 42.7684 16.9363C42.8996 17.0675 43.2934 17.5925 43.2934 17.5925H43.5559C43.5559 17.5925 43.8184 17.4613 43.8184 17.33C43.8184 17.33 42.8996 16.2801 42.8996 16.1488C42.8996 16.0176 42.7684 15.8863 43.1621 15.7551C43.4246 15.7551 44.4746 15.4926 44.4746 15.4926C44.4746 15.4926 44.4746 15.2301 44.4746 15.0988L44.2121 14.9676C44.2121 14.9676 43.2934 15.3613 43.1621 15.0988C43.1621 14.8363 43.9496 14.7051 44.0809 14.7051L44.2121 14.4426L44.0809 14.1801L42.6371 14.7051C42.5059 14.7051 42.3746 14.5738 42.3746 14.4426C42.3746 14.3113 42.3746 12.9988 42.5059 12.9988L42.2434 12.8676L42.1121 12.9988C42.1121 12.9988 42.2434 14.0488 41.9809 14.0488C41.8496 14.0488 41.7184 13.7863 41.8496 12.9988L41.7184 12.7363C41.9809 12.8676 41.7184 12.8676 41.5871 12.9988Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5374 17.5914C40.5374 17.5914 41.1936 16.6727 41.4561 16.5414C41.7186 16.4102 41.9811 16.2789 41.8499 16.6727C41.7186 17.0664 41.8499 16.9352 41.4561 17.4602L41.0624 17.9851V17.7227C41.0624 17.7227 41.3249 17.3289 41.4561 17.0664C41.4561 17.0664 41.5874 16.8039 41.4561 16.8039C41.3249 16.8039 41.1936 16.9352 41.0624 17.0664C40.9311 17.1977 40.6686 17.5914 40.5374 17.5914Z",
    fill: "url(#paint44_linear_9942_107848)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M39.616 14.9664C39.616 14.9664 40.5348 15.3601 41.0598 15.3601C41.0598 15.3601 41.191 15.3601 41.3223 15.2289C41.3223 15.0976 41.191 14.9664 41.0598 14.9664C41.0598 14.9664 39.8785 14.4414 39.7473 14.4414L39.8785 14.7039C39.8785 14.7039 40.666 14.9664 40.7973 15.0977C40.7973 15.0977 40.9285 15.0976 40.7973 15.2289C40.7973 15.3601 40.666 15.2289 40.4035 15.2289C40.2723 15.2289 39.7473 15.0976 39.7473 14.9664C39.8785 14.8351 39.7473 14.9664 39.616 14.9664Z",
    fill: "url(#paint45_linear_9942_107848)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9785 12.8672C41.9785 12.8672 41.9785 14.0484 42.1098 14.1797C42.241 14.4422 42.241 14.5734 42.3723 14.4422C42.5035 14.4422 42.6348 14.1797 42.6348 13.9172C42.6348 13.6547 42.6348 12.8672 42.6348 12.8672L42.5035 12.9984C42.5035 12.9984 42.5035 13.7859 42.5035 13.9172C42.5035 14.0484 42.5035 14.0484 42.3723 14.0484C42.3723 14.0484 42.241 14.0484 42.241 13.7859C42.241 13.5234 42.241 13.2609 42.241 12.9984L41.9785 12.8672Z",
    fill: "url(#paint46_linear_9942_107848)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7359 14.4414C44.7359 14.4414 43.6859 14.8351 43.4234 14.9664C43.2922 15.0976 43.1609 15.3601 43.6859 15.3601C44.2109 15.3601 44.8672 15.0977 44.8672 15.0977L44.6047 14.9664C44.6047 14.9664 43.9484 15.2289 43.8172 15.2289C43.6859 15.2289 43.5547 15.2289 43.6859 14.9664C43.9484 14.8351 44.4734 14.7039 44.4734 14.7039L44.7359 14.4414Z",
    fill: "url(#paint47_linear_9942_107848)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8988 16.4099C42.7676 16.4099 42.7676 16.6724 42.8988 16.9349C43.0301 17.1974 43.5551 17.8536 43.5551 17.8536V17.5911C43.5551 17.5911 42.8988 16.8036 43.0301 16.6724C43.0301 16.6724 43.1613 16.6724 43.4238 16.9349C43.6863 17.3286 43.8176 17.4599 43.8176 17.4599H44.0801C44.0801 17.4599 43.4238 16.5411 43.1613 16.4099C43.1613 16.4099 43.0301 16.2786 42.8988 16.4099Z",
    fill: "url(#paint48_linear_9942_107848)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8496 14.8359C41.8496 14.8359 41.7184 14.7047 41.5871 14.7047C41.4559 14.7047 40.1434 14.1797 40.0121 14.1797L39.8809 14.4422C39.8809 14.4422 41.1934 14.8359 41.3246 15.0984C41.4559 15.2297 41.4559 15.2297 41.4559 15.2297C41.5871 15.3609 41.8496 14.8359 41.8496 14.8359Z",
    fill: "url(#paint49_linear_9942_107848)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3245 15.3625C41.3245 15.3625 41.062 15.3625 40.9308 15.3625C40.7995 15.3625 40.2745 15.2312 39.4871 14.9688V15.3625C39.4871 15.3625 40.012 15.4937 40.9308 15.7562L41.1933 15.8875C41.3245 16.0187 41.4558 15.625 41.3245 15.3625Z",
    fill: "url(#paint50_linear_9942_107848)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3246 15.8845C41.3246 15.8845 41.3246 16.0158 41.0621 16.2783C40.7996 16.5408 40.2746 17.197 40.2746 17.3283C40.2746 17.3283 40.4059 17.5908 40.5371 17.5908C40.5371 17.5908 41.1934 16.5408 41.5871 16.4095C41.7184 16.4095 41.8496 16.4095 41.8496 16.4095C41.7184 16.4095 41.5871 15.7533 41.3246 15.8845Z",
    fill: "url(#paint51_linear_9942_107848)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9304 17.8536C40.9304 17.8536 41.5866 16.9349 41.5866 16.8036C41.5866 16.6724 41.7178 16.4099 41.7178 16.4099C41.7178 16.2786 42.1116 16.4099 42.1116 16.4099C42.2428 16.5411 42.1116 16.5411 42.1116 16.5411L41.8491 16.8036L41.1928 17.8536C41.1928 17.8536 41.0616 17.9849 40.9304 17.8536Z",
    fill: "url(#paint52_linear_9942_107848)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3734 16.5412C42.3734 16.6724 42.5047 16.6724 42.6359 16.9349C42.8984 17.3287 42.8984 17.5912 43.1609 17.8537L43.2922 17.9849L43.5547 17.8537C43.5547 17.8537 42.5047 16.6724 42.8984 16.4099C42.8984 16.4099 42.5047 16.1474 42.3734 16.5412Z",
    fill: "url(#paint53_linear_9942_107848)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9 16.2801C42.9 16.2801 43.0313 16.2801 43.1625 16.4113C43.1625 16.4113 43.5563 16.8051 44.0813 17.4613C44.0813 17.4613 44.3438 17.3301 44.3438 17.1988C44.3438 17.1988 43.5563 16.1488 43.425 16.0176C43.2938 16.0176 43.0313 16.2801 42.9 16.2801Z",
    fill: "url(#paint54_linear_9942_107848)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2925 15.2289C43.2925 15.2289 43.4237 15.3601 43.6862 15.3601C44.08 15.3601 44.8674 15.0977 44.8674 15.0977C44.8674 15.0977 44.9987 15.3602 44.8674 15.4914C44.8674 15.4914 44.3425 15.6226 43.4237 15.8851C43.4237 15.8851 43.1612 15.6226 43.2925 15.2289Z",
    fill: "url(#paint55_linear_9942_107848)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6047 14.1797C44.6047 14.1797 43.5547 14.5734 43.1609 14.7047C43.1609 14.7047 43.0297 14.7047 43.0297 14.5734C43.0297 14.4422 43.1609 15.0984 43.4234 15.0984C43.4234 15.0984 43.4234 14.9672 43.5547 14.8359C43.6859 14.7047 44.7359 14.3109 44.8672 14.3109C44.7359 14.4422 44.6047 14.1797 44.6047 14.1797Z",
    fill: "url(#paint56_linear_9942_107848)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6359 12.8672C42.6359 12.8672 42.6359 13.9172 42.6359 14.0484C42.6359 14.1797 42.6359 14.4422 42.3734 14.4422C42.3734 14.4422 42.6359 14.7047 42.8984 14.5734C42.8984 14.4422 42.8984 14.4422 42.8984 14.3109C42.8984 14.1797 42.8984 12.9984 42.8984 12.9984L42.6359 12.8672Z",
    fill: "url(#paint57_linear_9942_107848)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5862 12.9984C41.5862 12.9984 41.8486 12.8672 41.9799 12.8672C41.9799 13.1297 41.9799 13.6547 42.1111 14.0484C42.1111 14.0484 42.2424 14.4422 42.3736 14.4422C42.5049 14.4422 41.9799 14.5734 41.8486 14.5734C41.7174 14.5734 41.5862 13.1297 41.5862 12.9984Z",
    fill: "url(#paint58_linear_9942_107848)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M43.291 15.491C43.291 16.016 42.8973 16.4098 42.3723 16.4098C41.8473 16.4098 41.4535 16.016 41.4535 15.491C41.4535 14.966 41.8473 14.5723 42.3723 14.5723C42.8973 14.5723 43.291 14.966 43.291 15.491Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1602 15.491C43.1602 16.016 42.7664 16.4098 42.2414 16.4098C41.7164 16.4098 41.3227 16.016 41.3227 15.491C41.3227 14.966 41.7164 14.5723 42.2414 14.5723C42.7664 14.5723 43.1602 14.966 43.1602 15.491Z",
    fill: "#FAFAFA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1602 15.4906C43.1602 15.8844 42.7664 16.2781 42.3727 16.2781C41.9789 16.2781 41.5852 15.8844 41.5852 15.4906C41.5852 15.0969 41.9789 14.7031 42.3727 14.7031C42.7664 14.7031 43.1602 14.9656 43.1602 15.4906Z",
    fill: "#F4F4F5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0273 15.4906C43.0273 15.8843 42.7648 16.2781 42.3711 16.2781C41.9774 16.2781 41.5836 16.0156 41.5836 15.6218C41.5836 15.2281 41.8461 14.8343 42.2399 14.8343C42.6336 14.7031 43.0273 15.0968 43.0273 15.4906Z",
    fill: "#EFEFF0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0273 15.4922C43.0273 15.8859 42.7648 16.1484 42.3711 16.1484C41.9774 16.1484 41.7149 15.8859 41.7149 15.4922C41.7149 15.0984 41.9774 14.8359 42.3711 14.8359C42.6336 14.8359 43.0273 15.0984 43.0273 15.4922Z",
    fill: "#E9EAEB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8984 15.4908C42.8984 15.7533 42.6359 16.147 42.3734 16.147C42.1109 16.147 41.7172 15.8845 41.7172 15.622C41.7172 15.3595 41.9797 14.9658 42.2422 14.9658C42.6359 14.8345 42.8984 15.097 42.8984 15.4908Z",
    fill: "#E4E4E6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8984 15.4898C42.8984 15.7523 42.7672 16.0148 42.5047 16.0148C42.2422 16.0148 41.9797 15.8836 41.9797 15.6211C41.9797 15.3586 42.1109 15.0961 42.3734 15.0961C42.5047 14.9648 42.7672 15.0961 42.8984 15.4898Z",
    fill: "#DFDFE1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7676 15.4892C42.7676 15.7517 42.6363 16.0142 42.3738 16.0142C42.1113 16.0142 41.8488 15.8829 41.8488 15.6204C41.8488 15.358 41.9801 15.0955 42.2426 15.0955C42.5051 14.9642 42.7676 15.2267 42.7676 15.4892Z",
    fill: "#D9DADC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6348 15.3582C42.6348 15.6207 42.5035 15.7519 42.3723 15.7519C42.1098 15.7519 41.9785 15.6207 41.9785 15.4894C41.9785 15.227 42.1098 15.0957 42.241 15.0957C42.5035 15.0957 42.6348 15.2269 42.6348 15.3582Z",
    fill: "#D4D5D7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6348 15.3582C42.6348 15.4894 42.6348 15.7519 42.3723 15.7519C42.241 15.7519 41.9785 15.7519 41.9785 15.4894C41.9785 15.3582 41.9785 15.0957 42.241 15.0957C42.3723 15.0957 42.6348 15.2269 42.6348 15.3582Z",
    fill: "#CFCFD2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5039 15.3598C42.5039 15.491 42.5039 15.6223 42.3727 15.6223C42.2414 15.6223 42.1102 15.6223 42.1102 15.491C42.1102 15.3598 42.1102 15.2285 42.2414 15.2285C42.3727 15.2285 42.5039 15.2285 42.5039 15.3598Z",
    fill: "#C9CACD"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5039 15.3594C42.5039 15.4906 42.5039 15.6219 42.5039 15.6219C42.3727 15.6219 42.2414 15.6219 42.2414 15.6219C42.2414 15.4906 42.2414 15.3594 42.2414 15.3594C42.2414 15.3594 42.3727 15.3594 42.5039 15.3594Z",
    fill: "#C4C5C8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3723 15.3598C42.5035 15.3598 42.5035 15.491 42.3723 15.3598C42.3723 15.6223 42.241 15.6223 42.1098 15.491C41.9785 15.491 41.9785 15.3598 42.1098 15.2285C42.241 15.3598 42.3723 15.3598 42.3723 15.3598Z",
    fill: "#BEBFC3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5039 15.4906C42.5039 15.6219 42.5039 15.6219 42.3727 15.6219C42.2414 15.6219 42.2414 15.6219 42.2414 15.4906C42.2414 15.3594 42.2414 15.3594 42.3727 15.3594L42.5039 15.4906Z",
    fill: "#B9BABE"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0312 15.4922C43.0312 15.8859 42.7688 16.1484 42.375 16.1484C41.9813 16.1484 41.7188 15.8859 41.7188 15.4922C41.7188 15.0984 41.9813 14.8359 42.375 14.8359C42.7688 14.8359 43.0312 15.2297 43.0312 15.4922Z",
    fill: "url(#paint59_linear_9942_107848)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4543 15.4926C41.4543 15.6238 41.5855 15.6238 41.5855 15.6238C41.7168 15.6238 41.7168 15.4926 41.7168 15.4926C41.7168 15.3613 41.5855 15.3613 41.5855 15.3613L41.4543 15.4926Z",
    fill: "url(#paint60_linear_9942_107848)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5852 15.4926C41.5852 15.6238 41.7164 15.6238 41.7164 15.6238C41.8477 15.6238 41.8477 15.4926 41.8477 15.4926C41.8477 15.3613 41.7164 15.3613 41.7164 15.3613C41.5852 15.3613 41.5852 15.4926 41.5852 15.4926Z",
    fill: "#232020"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7164 15.3613V15.4926L41.8477 15.6238H41.7164H41.5852V15.4926L41.7164 15.3613Z",
    fill: "url(#paint61_linear_9942_107848)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5856 15.4922C41.5856 15.6234 41.5856 15.6234 41.5856 15.4922C41.7168 15.6234 41.7168 15.4922 41.7168 15.4922C41.7168 15.4922 41.7168 15.4922 41.5856 15.4922Z",
    fill: "#232020"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5856 15.4922C41.5856 15.6234 41.5856 15.6234 41.5856 15.4922C41.7168 15.6234 41.7168 15.4922 41.7168 15.4922C41.7168 15.4922 41.7168 15.4922 41.5856 15.4922Z",
    fill: "url(#paint62_linear_9942_107848)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7168 15.6234C41.7168 15.4922 41.7168 15.6234 41.7168 15.6234C41.5856 15.4922 41.5856 15.4922 41.5856 15.4922V15.6234C41.7168 15.6234 41.7168 15.6234 41.7168 15.6234Z",
    fill: "url(#paint63_linear_9942_107848)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2414 14.8363C42.2414 14.9676 42.3727 14.9676 42.3727 14.9676C42.5039 14.9676 42.5039 14.8363 42.5039 14.8363C42.5039 14.7051 42.3727 14.7051 42.3727 14.7051C42.2414 14.7051 42.2414 14.8363 42.2414 14.8363Z",
    fill: "url(#paint64_linear_9942_107848)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2414 14.8363C42.2414 14.9676 42.3727 14.9676 42.3727 14.9676C42.5039 14.9676 42.5039 14.8363 42.5039 14.8363C42.5039 14.7051 42.3727 14.7051 42.3727 14.7051C42.2414 14.7051 42.2414 14.8363 42.2414 14.8363Z",
    fill: "#232020"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3727 14.7051L42.5039 14.8363V14.9676H42.3727H42.2414V14.8363L42.3727 14.7051Z",
    fill: "url(#paint65_linear_9942_107848)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2421 14.8359C42.2421 14.9672 42.2421 14.9672 42.2421 14.8359C42.3734 14.9672 42.3734 14.8359 42.3734 14.8359C42.5046 14.8359 42.3734 14.8359 42.2421 14.8359Z",
    fill: "#232020"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2418 14.8359C42.2418 14.9672 42.2418 14.9672 42.2418 14.8359C42.373 14.9672 42.373 14.8359 42.373 14.8359C42.373 14.8359 42.373 14.8359 42.2418 14.8359Z",
    fill: "url(#paint66_linear_9942_107848)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M42.373 14.9672C42.373 14.8359 42.373 14.9672 42.373 14.9672C42.2418 14.8359 42.2418 14.8359 42.2418 14.8359V14.9672C42.373 14.9672 42.373 14.9672 42.373 14.9672Z",
    fill: "url(#paint67_linear_9942_107848)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8977 15.6231C42.8977 15.7544 43.0289 15.7544 43.0289 15.7544C43.1602 15.7544 43.1602 15.6231 43.1602 15.6231C43.1602 15.4919 43.0289 15.4919 43.0289 15.4919C42.8977 15.3606 42.8977 15.4919 42.8977 15.6231Z",
    fill: "url(#paint68_linear_9942_107848)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8977 15.6231C42.8977 15.7544 43.0289 15.7544 43.0289 15.7544C43.1602 15.7544 43.1602 15.6231 43.1602 15.6231C43.1602 15.4919 43.0289 15.4919 43.0289 15.4919C42.8977 15.3606 42.8977 15.4919 42.8977 15.6231Z",
    fill: "#232020"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0289 15.4922H43.1602V15.6234L43.0289 15.7547L42.8977 15.6234V15.4922H43.0289Z",
    fill: "url(#paint69_linear_9942_107848)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8981 15.6238C43.0293 15.7551 43.0293 15.6238 43.0293 15.6238C43.0293 15.4926 43.0293 15.4926 42.8981 15.6238C42.8981 15.4926 42.8981 15.4926 42.8981 15.6238Z",
    fill: "#232020"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8981 15.6238C43.0293 15.7551 43.0293 15.6238 43.0293 15.6238C43.0293 15.4926 43.0293 15.4926 42.8981 15.6238C42.8981 15.4926 42.8981 15.4926 42.8981 15.6238Z",
    fill: "url(#paint70_linear_9942_107848)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0293 15.6234C43.0293 15.4922 43.0293 15.6234 43.0293 15.6234C42.8981 15.4922 42.8981 15.4922 42.8981 15.4922V15.6234C43.0293 15.6234 43.0293 15.6234 43.0293 15.6234Z",
    fill: "url(#paint71_linear_9942_107848)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2414 16.1488C42.2414 16.2801 42.3727 16.2801 42.3727 16.2801C42.5039 16.2801 42.5039 16.1488 42.5039 16.1488C42.5039 16.0176 42.3727 16.0176 42.3727 16.0176C42.2414 16.0176 42.2414 16.1488 42.2414 16.1488Z",
    fill: "url(#paint72_linear_9942_107848)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2414 16.1488C42.2414 16.2801 42.3727 16.2801 42.3727 16.2801C42.5039 16.2801 42.5039 16.1488 42.5039 16.1488C42.5039 16.0176 42.3727 16.0176 42.3727 16.0176C42.2414 16.0176 42.2414 16.1488 42.2414 16.1488Z",
    fill: "#232020"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3727 16.1484H42.5039V16.2797H42.3727H42.2414V16.1484H42.3727Z",
    fill: "url(#paint73_linear_9942_107848)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2421 16.1484C42.2421 16.2797 42.2421 16.2797 42.2421 16.1484C42.3734 16.2797 42.3734 16.1484 42.3734 16.1484C42.5046 16.1484 42.3734 16.1484 42.2421 16.1484Z",
    fill: "#232020"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2418 16.1484C42.2418 16.2797 42.2418 16.2797 42.2418 16.1484C42.373 16.2797 42.373 16.1484 42.373 16.1484C42.373 16.1484 42.373 16.1484 42.2418 16.1484Z",
    fill: "url(#paint74_linear_9942_107848)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M42.373 16.2797C42.373 16.1484 42.373 16.2797 42.373 16.2797C42.2418 16.1484 42.2418 16.1484 42.2418 16.1484V16.2797C42.373 16.2797 42.373 16.2797 42.373 16.2797Z",
    fill: "url(#paint75_linear_9942_107848)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6387 15.4914C42.6387 15.7539 42.5074 15.8851 42.2449 15.8851C41.9824 15.8851 41.8512 15.7539 41.8512 15.4914C41.8512 15.2289 41.9824 15.0977 42.2449 15.0977C42.5074 15.0977 42.6387 15.3602 42.6387 15.4914Z",
    fill: "#F4F4F4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M38.568 15.6231C38.568 15.6231 38.568 13.6543 40.143 12.4731C41.718 11.2919 43.5555 12.0794 43.6867 12.2106C43.818 12.3418 41.9805 11.1606 40.2742 12.6043C38.568 13.9168 38.568 15.6231 38.568 15.6231Z",
    fill: "#47413E"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68708 15.621C1.42458 15.2273 1.16208 13.1273 1.16208 12.996C1.16208 12.8648 1.42458 12.7335 1.42458 12.7335C1.42458 12.7335 1.55583 7.87733 2.47457 5.12109C3.13082 3.02111 4.44331 1.97112 4.44331 1.97112C4.44331 1.97112 4.18081 1.83987 4.18081 1.70862C4.18081 1.57737 5.88705 1.18362 6.2808 1.18362C6.67454 1.18362 10.7433 0.527378 11.3995 0.396129C12.0558 0.396129 25.7057 -1.04761 32.1369 1.57737C32.1369 1.57737 37.6493 3.8086 41.9805 6.03984C41.9805 6.03984 42.3743 6.17109 43.1618 6.43359C43.9493 6.69608 50.5117 8.13983 51.4305 10.2398C52.3492 12.3398 52.3492 12.0773 52.4805 13.3898C52.4805 14.571 52.3492 14.9648 52.0867 16.0148C51.4305 16.4085 48.9367 16.9335 47.2305 16.9335C47.2305 16.9335 47.3618 15.096 47.2305 14.571C47.0993 14.046 46.968 12.6023 44.6055 11.2898C42.243 9.97731 39.8806 11.5523 39.2243 12.3398C38.6993 13.1273 38.0431 13.6523 37.9118 16.8023L13.6307 16.9335C13.6307 16.9335 13.6307 14.046 12.5807 12.7335C11.5308 11.2898 11.3995 10.8961 8.64328 10.7648C8.64328 10.7648 6.41204 10.7648 4.83705 13.1273C4.04956 14.8335 4.18081 16.4085 4.18081 16.4085C4.18081 16.4085 2.86832 16.2773 1.68708 15.621Z",
    fill: "url(#paint76_linear_9942_107848)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60512 8.40234L3.91761 10.8961C3.91761 10.8961 4.31136 11.6836 4.57386 11.8148C4.83635 11.9461 5.2301 12.0773 5.2301 12.0773C5.2301 12.0773 6.41134 11.1586 6.80509 10.8961C7.19884 10.6336 9.95507 9.84609 11.7926 11.4211C12.9738 12.6023 13.2363 12.7336 13.4988 12.6023C13.7613 12.4711 13.7613 11.9461 13.8925 12.0773C14.0238 12.2086 14.2863 12.3398 14.5488 12.7336C14.5488 12.7336 13.105 10.6336 12.5801 10.2398C12.5801 10.2398 13.2363 10.7648 13.63 10.7648C13.63 10.7648 24.3925 11.2898 27.28 11.4211C30.1674 11.5523 37.2549 11.5523 37.2549 11.5523C37.3861 11.5523 38.8299 12.0773 38.9611 12.0773C38.9611 12.0773 40.5361 10.6336 42.2424 10.7648C42.2424 10.7648 45.7861 10.5023 47.2298 13.3898L48.0173 13.1273C48.0173 13.1273 48.8048 14.1773 49.3298 14.0461C49.8548 13.9148 49.9861 12.8648 49.8548 12.3398C49.8548 12.3398 51.4298 12.2086 51.8235 12.0773C52.2173 11.9461 52.3485 12.4711 52.3485 12.7336C52.3485 12.9961 52.611 15.4898 51.9548 16.2773C51.9548 16.2773 50.6423 17.0648 46.9673 17.3273C46.9673 17.3273 47.4923 14.1773 45.6548 12.6023C43.9486 11.0273 40.9299 9.97733 38.5674 13.3898C38.5674 13.3898 38.0424 13.9148 37.7799 17.196L13.63 16.9335C13.63 16.9335 13.8925 13.7836 12.1863 12.3398C12.1863 12.3398 8.11758 8.53359 4.96761 13.6523C4.96761 13.6523 4.57386 14.7023 4.57386 16.4085C4.57386 16.4085 4.31136 16.9335 1.68638 15.7523C1.68638 15.7523 1.03013 13.3898 1.16138 13.1273C1.29263 12.8648 1.42388 12.8648 1.42388 12.8648C1.42388 12.8648 1.42388 11.1586 1.81763 8.53359C1.81763 8.2711 2.34262 8.53359 2.60512 8.40234Z",
    fill: "url(#paint77_linear_9942_107848)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3369 14.3086L36.7305 15.6211L14.9431 15.0961L15.3369 14.3086Z",
    fill: "url(#paint78_linear_9942_107848)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0865 13.7832C52.0865 13.7832 51.4302 14.3082 50.6428 14.4395C50.6428 14.4395 50.5115 14.7019 50.3803 15.2269C50.3803 15.8832 50.3803 15.8832 50.3803 15.8832C50.3803 15.8832 51.4302 15.7519 51.824 15.4894C51.824 15.4894 52.2177 14.3082 52.0865 13.7832Z",
    fill: "#59595B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6428 14.5699C50.6428 14.5699 51.6928 14.3074 51.9553 14.0449C52.0866 14.0449 51.9553 14.1762 51.9553 14.3074C51.9553 14.3074 51.2991 14.7012 51.1678 14.7012C50.9053 14.7012 50.6428 14.8324 50.6428 14.8324V14.5699Z",
    fill: "url(#paint79_linear_9942_107848)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31174 1.7082C4.31174 1.7082 5.36173 1.7082 5.88672 1.4457C6.41172 1.31445 6.54297 1.31445 6.54297 1.31445V1.7082C6.54297 1.7082 5.36173 1.9707 5.23048 2.2332C4.96798 2.36445 3.78674 1.57695 4.31174 1.7082Z",
    fill: "url(#paint80_linear_9942_107848)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54041 1.31445L6.40916 1.7082C6.40916 1.7082 12.3154 0.264455 23.8653 0.789452C23.8653 0.789452 27.6715 1.05195 31.084 2.36444C31.084 2.36444 28.8528 0.789451 21.2403 0.526952C17.9591 0.395703 15.5966 0.264455 6.54041 1.31445Z",
    fill: "url(#paint81_linear_9942_107848)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5478 16.0137L13.6291 16.9324L37.9102 17.0637L37.2539 16.2762L14.5478 16.0137Z",
    fill: "url(#paint82_linear_9942_107848)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42383 12.7324C1.42383 12.7324 1.16133 12.7324 1.16133 12.9949H1.42383V12.7324Z",
    fill: "url(#paint83_linear_9942_107848)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95039 8.5332C1.95039 8.5332 1.29414 12.3394 1.81914 14.8332C1.81914 14.8332 1.55664 12.6019 2.21289 8.5332H1.95039Z",
    fill: "url(#paint84_linear_9942_107848)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6443 12.0785C50.6443 12.0785 51.0381 13.6535 50.9068 13.7848C50.7756 14.0473 50.3818 14.3097 50.2506 14.0472C50.1193 13.7848 49.8568 11.9473 49.8568 11.9473L50.6443 12.0785Z",
    fill: "url(#paint85_linear_9942_107848)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5104 14.4394C50.3791 14.4394 50.2479 14.4394 50.1166 14.7019C49.9854 15.0957 49.9854 16.0144 50.1166 16.0144C50.2479 16.0144 51.0354 15.7519 51.0354 15.7519C51.0354 15.7519 50.3791 15.8832 50.3791 15.7519C50.3791 15.6207 50.5104 14.3082 50.5104 14.4394C50.7729 14.3082 51.5604 14.0457 51.5604 14.0457C51.5604 14.0457 52.3479 13.5207 52.4791 13.3894C52.6104 13.2582 52.0854 11.8145 51.9541 11.8145C51.8229 11.8145 52.0854 12.7332 51.8229 13.1269C51.5604 13.7832 51.5604 14.1769 50.5104 14.4394Z",
    fill: "url(#paint86_linear_9942_107848)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4988 7.61641C13.4988 7.61641 13.63 7.22266 14.2863 7.22266C14.9425 7.35391 15.3363 7.74765 14.9425 8.27265C14.9425 8.27265 14.8113 8.53515 14.2863 8.53515C13.63 8.53515 13.2363 8.1414 13.4988 7.61641Z",
    fill: "url(#paint87_linear_9942_107848)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4967 7.61741C13.4967 7.61741 13.6279 7.22366 14.2842 7.35491C14.9404 7.35491 15.2029 7.74866 14.9404 8.27365C14.9404 8.27365 14.8092 8.53615 14.2842 8.53615C13.7592 8.53615 13.3654 8.14241 13.4967 7.61741Z",
    fill: "url(#paint88_linear_9942_107848)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6293 7.61601C13.6293 7.61601 13.7606 7.35352 14.1543 7.35352C14.6793 7.35352 14.8105 7.61601 14.8105 7.61601C14.8105 7.61601 14.548 7.35352 14.1543 7.35352C13.8918 7.48476 13.6293 7.61601 13.6293 7.61601Z",
    fill: "url(#paint89_linear_9942_107848)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6293 8.0095C13.6293 8.0095 13.7606 8.40325 14.0231 8.40325C14.2855 8.40325 14.4168 8.5345 14.6793 8.272C14.8105 8.14076 14.8105 8.0095 14.8105 8.0095C14.8105 8.0095 13.8918 7.87826 13.6293 8.0095Z",
    fill: "url(#paint90_linear_9942_107848)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7606 8.00977C13.7606 8.14101 13.6293 8.00977 13.7606 8.00977C13.8918 8.14101 13.8918 8.14102 13.8918 8.27226C13.8918 8.27226 14.0231 8.40351 14.1543 8.40351C14.4168 8.40351 14.548 8.40351 14.548 8.40351C14.548 8.40351 14.6793 8.27226 14.8105 8.27226V8.14102H14.2856H14.548V8.27226H14.4168C14.4168 8.27226 14.548 8.27226 14.548 8.40351C14.4168 8.40351 14.0231 8.40351 14.0231 8.40351V8.27226C14.0231 8.27226 14.1543 8.27226 14.2856 8.27226H14.4168C14.4168 8.27226 14.2856 8.27226 14.1543 8.27226C14.1543 8.27226 14.0231 8.27226 13.8918 8.27226C13.8918 8.27226 14.0231 8.27226 14.1543 8.27226L13.7606 8.00977Z",
    fill: "url(#paint91_linear_9942_107848)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7102 7.74648L13.3664 7.61523H13.4977C13.4977 7.61523 14.0227 7.61523 14.2852 7.61523C14.2852 7.61523 14.8102 7.61523 14.9414 7.61523C15.0727 7.61523 15.0727 7.61523 15.0727 7.61523C15.0727 7.61523 15.4664 7.74648 15.5977 7.74648V8.00898L15.0727 8.14023L14.9414 8.00898C14.9414 8.00898 14.5477 8.00898 14.2852 8.00898C14.1539 8.00898 13.7602 8.00898 13.6289 8.00898C13.4977 8.00898 13.4977 8.14023 13.4977 8.14023L12.8414 8.00898C12.7102 8.00898 12.7102 7.74648 12.7102 7.74648Z",
    fill: "#BFBFBF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7102 8.00977C12.7102 8.00977 13.4977 8.00977 13.7602 8.00977C14.0227 8.00977 15.2039 8.00977 15.3352 8.00977C15.4664 8.00977 15.5977 8.00977 15.5977 8.00977L15.0727 8.14101L14.9414 8.00977C14.9414 8.00977 14.4164 8.00977 14.2852 8.00977C14.1539 8.00977 13.7602 8.00977 13.6289 8.00977C13.4977 8.00977 13.4977 8.00977 13.4977 8.00977C13.4977 8.00977 12.8414 8.00977 12.7102 8.00977Z",
    fill: "url(#paint92_linear_9942_107848)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8418 7.74883C12.8418 7.74883 13.6293 7.74883 13.7606 7.74883C13.8918 7.74883 14.8106 7.74883 14.8106 7.74883C14.9418 7.74883 15.3355 7.74883 15.4668 7.74883L14.9418 7.61758C14.9418 7.61758 14.9418 7.61758 14.8106 7.61758C14.6793 7.61758 14.1543 7.61758 14.1543 7.61758C14.0231 7.61758 13.4981 7.61758 13.3668 7.48633C13.3668 7.61758 12.9731 7.61758 12.8418 7.74883Z",
    fill: "url(#paint93_linear_9942_107848)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9675 8.40351C25.9675 8.40351 26.0988 8.00977 26.755 8.00977C27.4113 8.14101 27.805 8.53476 27.4113 9.05976C27.4113 9.05976 27.28 9.32226 26.755 9.32226C26.0988 9.32226 25.705 8.92851 25.9675 8.40351Z",
    fill: "url(#paint94_linear_9942_107848)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9654 8.40452C25.9654 8.40452 26.0967 8.01077 26.7529 8.14202C27.4092 8.27327 27.6717 8.66701 27.4092 9.06076C27.4092 9.06076 27.2779 9.32326 26.7529 9.32326C26.0967 9.32326 25.8342 8.92951 25.9654 8.40452Z",
    fill: "url(#paint95_linear_9942_107848)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0981 8.40312C26.0981 8.40312 26.2293 8.14062 26.6231 8.14062C27.148 8.14062 27.2793 8.40312 27.2793 8.40312C27.2793 8.40312 27.0168 8.14062 26.6231 8.14062C26.3606 8.27187 26.0981 8.40312 26.0981 8.40312Z",
    fill: "url(#paint96_linear_9942_107848)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0981 8.79765C26.0981 8.79765 26.2293 9.1914 26.4918 9.1914C26.7543 9.1914 26.8856 9.32265 27.148 9.06015C27.2793 8.9289 27.2793 8.79765 27.2793 8.79765C27.2793 8.9289 26.3606 8.6664 26.0981 8.79765Z",
    fill: "url(#paint97_linear_9942_107848)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2293 8.92718C26.2293 8.92718 26.0981 8.92718 26.2293 8.92718C26.3606 9.05843 26.3606 9.05842 26.3606 9.18967C26.3606 9.18967 26.4918 9.32092 26.6231 9.32092C26.8856 9.32092 27.0168 9.32092 27.0168 9.32092C27.0168 9.32092 27.148 9.18967 27.2793 9.18967V9.05842H26.7543H27.0168V9.18967H26.8856C26.8856 9.18967 27.0168 9.18967 27.0168 9.32092C26.8856 9.32092 26.4918 9.32092 26.4918 9.32092V9.18967C26.4918 9.18967 26.6231 9.18967 26.7543 9.18967H26.8856C26.8856 9.18967 26.7543 9.18967 26.6231 9.18967C26.6231 9.18967 26.4918 9.18967 26.3606 9.18967C26.3606 9.18967 26.4918 9.18967 26.6231 9.18967C26.6231 9.18967 26.2293 8.79593 26.2293 8.92718Z",
    fill: "url(#paint98_linear_9942_107848)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1789 8.53359L25.8352 8.40234H25.9664C25.9664 8.40234 26.4914 8.40234 26.7539 8.40234C26.7539 8.40234 27.2789 8.40234 27.4102 8.40234C27.5414 8.40234 27.5414 8.40234 27.5414 8.40234L28.0664 8.53359V8.79609L27.5414 8.92734L27.4102 8.79609C27.4102 8.79609 27.0164 8.79609 26.7539 8.79609C26.6227 8.79609 26.2289 8.79609 26.0977 8.79609C25.9664 8.79609 25.9664 8.92734 25.9664 8.92734L25.3102 8.79609C25.1789 8.79609 25.1789 8.53359 25.1789 8.53359Z",
    fill: "#BFBFBF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1789 8.79688C25.1789 8.79688 25.9664 8.79688 26.2289 8.79688C26.4914 8.79688 27.6727 8.79688 27.8039 8.79688C27.9352 8.79688 28.0664 8.79688 28.0664 8.79688L27.5414 8.92812L27.4102 8.79688C27.4102 8.79688 26.8852 8.79688 26.7539 8.79688C26.6227 8.79688 26.2289 8.79688 26.0977 8.79688C25.9664 8.79688 25.9664 8.79688 25.9664 8.79688C25.9664 8.79688 25.3102 8.79688 25.1789 8.79688Z",
    fill: "url(#paint99_linear_9942_107848)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3102 8.53593C25.3102 8.53593 26.0977 8.53593 26.2289 8.53593C26.3602 8.53593 27.2789 8.53593 27.4102 8.53593C27.5414 8.53593 27.9352 8.53593 28.0664 8.53593L27.5414 8.40468C27.5414 8.40468 27.5414 8.40468 27.4102 8.40468C27.2789 8.40468 26.7539 8.40468 26.7539 8.40468C26.6227 8.40468 26.0977 8.40469 25.9664 8.27344C25.8352 8.40469 25.4414 8.53593 25.3102 8.53593Z",
    fill: "url(#paint100_linear_9942_107848)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91619 5.38218C3.91619 5.38218 5.62243 4.06969 9.95366 3.67594C12.9724 3.41344 18.4849 2.75719 22.4223 2.62594C22.4223 2.62594 31.216 3.01969 32.1348 3.15094C32.1348 3.15094 29.116 1.4447 24.2598 1.1822C19.4036 0.788455 15.5974 1.1822 11.6599 1.4447C7.72242 1.7072 5.75368 2.49469 5.49118 2.75719C5.22869 2.75719 3.91619 4.46343 3.91619 5.38218Z",
    fill: "url(#paint101_linear_9942_107848)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7461 7.3513L36.4649 7.22005L23.9962 6.5638L11.79 5.90756L3.3901 5.38256C3.3901 5.38256 3.78385 3.41382 5.22759 2.23258C5.22759 2.23258 7.59007 0.526343 22.0275 0.657592C22.0275 0.657592 28.0649 0.657593 32.1336 2.75758C35.4149 4.20132 37.7774 5.38256 39.7461 7.3513ZM39.0898 7.0888C37.1211 5.38256 34.8899 4.20132 31.7399 2.88883C27.9337 1.05134 22.0275 1.05134 22.0275 1.05134C7.98382 0.788843 5.75259 2.36383 5.75259 2.36383C4.30885 3.41383 3.9151 5.25131 3.9151 5.25131L12.0525 5.64506L23.865 6.30131L35.9399 6.95755L39.0898 7.0888Z",
    fill: "#59595B"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6411 1.31328C29.6411 1.31328 30.1661 1.18203 30.4286 1.05078C30.4286 1.05078 31.2161 1.44453 32.5286 1.96952C35.1536 3.01952 39.2223 4.857 41.716 6.43199C41.716 6.43199 42.1098 6.56324 41.3223 6.95699C38.6973 5.6445 36.0723 3.41326 29.6411 1.31328Z",
    fill: "url(#paint102_linear_9942_107848)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8785 6.03858C39.8785 6.03858 41.3223 5.90733 41.716 6.30108C41.716 6.30108 41.9785 6.43232 41.9785 6.56357C41.8473 6.69482 41.5848 6.95732 41.4535 6.95732L39.8785 6.03858Z",
    fill: "#B9BABE"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6114 1.70703C31.6114 1.70703 36.5989 3.67576 39.3551 5.382L41.4551 6.1695C41.4551 6.1695 37.7801 3.67576 30.4302 1.05078C30.4302 1.05078 31.4801 1.57578 31.6114 1.70703Z",
    fill: "#373535"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5848 6.16992H41.716L41.8473 6.30117C41.8473 6.30117 42.1098 6.30117 42.241 6.30117V6.43242H42.3723V6.30117L42.6348 6.43242V6.56367H42.766C42.766 6.56367 42.8973 6.56367 42.6348 6.82617C42.3723 7.08866 42.1098 7.08866 42.1098 7.08866L41.8473 6.95742L41.4535 6.69492C41.4535 6.69492 41.9785 6.43242 41.9785 6.16992C41.9785 6.43242 41.5848 6.16992 41.5848 6.16992Z",
    fill: "#232020"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5051 6.43359V6.69609L42.6363 6.82734L42.7676 6.56484C42.6363 6.56484 42.6363 6.43359 42.5051 6.43359Z",
    fill: "#59595B"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1086 6.82617C42.1086 6.82617 42.1086 6.95742 42.1086 6.82617C42.2398 6.95742 42.3711 6.95742 42.3711 6.95742C42.3711 6.95742 42.3711 6.82617 42.1086 6.82617C42.1086 6.82617 42.2398 6.82617 42.1086 6.82617Z",
    fill: "#59595B"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2414 6.82461C42.3727 6.95586 42.2414 6.82461 42.2414 6.82461C42.3727 6.95586 42.5039 6.82461 42.5039 6.82461C42.5039 6.82461 42.3727 6.82461 42.3727 6.69336C42.3727 6.69336 42.3727 6.82461 42.2414 6.82461C42.1102 6.82461 42.1102 6.82461 42.1102 6.82461H42.2414Z",
    fill: "#59595B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8484 6.30078L41.9797 6.43203C41.9797 6.56328 41.4547 6.82578 41.4547 6.82578C41.4547 6.82578 41.7172 6.95703 41.8484 6.95703C41.9797 6.95703 42.1109 6.69453 42.1109 6.56328C42.1109 6.56328 42.2422 6.43203 42.2422 6.30078C42.1109 6.43203 41.9797 6.30078 41.8484 6.30078Z",
    fill: "#59595B"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3336 4.98828L36.7274 6.95702H39.0898C39.0898 7.08827 38.1711 6.16952 36.3336 4.98828Z",
    fill: "#232020"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4649 5.12109L36.8586 6.95858H39.0898C38.9586 7.08983 38.1711 6.17109 36.4649 5.12109Z",
    fill: "url(#paint103_radial_9942_107848)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5229 5.38256C3.5229 5.38256 3.91665 3.41382 5.36039 2.23258C5.36039 2.23258 7.72287 0.526343 22.1603 0.657592C22.1603 0.657592 28.1977 0.657593 32.2665 2.75758C35.5477 4.20132 37.7789 5.38256 39.8789 7.3513L36.5977 7.22005L24.129 6.5638L11.9228 5.90756L3.5229 5.38256Z",
    fill: "url(#paint104_linear_9942_107848)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6152 7.3513L36.334 7.22005L23.8653 6.5638L11.6592 5.90756L3.25924 5.38256C3.25924 5.38256 3.65299 3.41382 5.09673 2.23258C5.09673 2.23258 7.45921 0.526343 21.8966 0.657592C21.8966 0.657592 27.9341 0.657593 32.0028 2.75758C35.284 4.20132 37.5152 5.38256 39.6152 7.3513ZM38.959 6.95755C36.9903 5.25131 34.759 4.07007 31.609 2.75758C27.8028 0.920091 21.8966 0.920091 21.8966 0.920091C7.85295 0.788842 5.62173 2.36383 5.62173 2.36383C4.17799 3.41383 3.78424 5.25131 3.78424 5.25131L11.9217 5.64506L23.7341 6.30131L35.809 6.95755H38.959Z",
    fill: "#414042"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2664 5.90673C11.2664 5.90673 12.8414 1.31302 12.9727 1.05052C12.9727 1.05052 14.1539 0.919271 14.2852 1.05052L12.5789 6.03798L11.2664 5.90673Z",
    fill: "url(#paint105_linear_9942_107848)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8172 0.787109L23.2109 6.56207L25.1797 6.69332C25.1797 6.69332 24.2609 1.04961 24.2609 0.918359C24.2609 0.918359 23.211 0.787109 22.8172 0.787109Z",
    fill: "url(#paint106_linear_9942_107848)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5488 4.46484L36.2051 7.22108H36.8613L36.3363 4.72734C36.3363 4.85859 35.8113 4.46484 35.5488 4.46484Z",
    fill: "url(#paint107_linear_9942_107848)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9666 8.66611C46.7041 8.79736 46.7041 9.05986 46.8353 9.19111C47.0978 9.32236 48.1478 9.9786 49.5916 11.9473C49.5916 11.9473 49.9853 12.0786 50.904 11.9473C51.954 11.8161 51.6915 11.8161 51.6915 11.8161C51.6915 11.8161 51.2978 10.6348 50.7728 10.2411C50.379 9.9786 47.8853 8.40361 46.9666 8.66611Z",
    fill: "#414042"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0985 8.79738C46.836 8.92862 46.836 9.05987 46.9673 9.32237C47.2298 9.45362 48.1485 9.97862 49.5923 11.8161C49.5923 11.8161 49.986 11.9474 50.9047 11.8161C51.8235 11.8161 51.561 11.6849 51.561 11.6849C51.561 11.6849 51.2985 10.6349 50.7735 10.2411C50.2485 9.97862 47.886 8.53488 47.0985 8.79738Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3586 9.05859C47.3586 9.05859 47.6211 9.18984 47.6211 9.32109C47.6211 9.32109 48.1461 9.18984 49.5898 9.71484C49.5898 9.71484 47.6211 9.05859 47.3586 9.05859Z",
    fill: "#B9BABE"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3586 8.92969C47.3586 8.92969 47.4899 8.92969 47.4899 9.06093C47.4899 9.06093 48.9336 9.32343 49.5898 9.58593C49.5898 9.71718 48.0149 9.06094 47.3586 8.92969Z",
    fill: "#B9BABE"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6387 10.3727H50.1137C50.1137 10.3727 49.8512 9.97891 49.5887 9.84766C49.5887 9.84766 49.7199 9.97891 49.8512 9.97891C49.9824 9.97891 49.5887 9.84766 49.5887 9.84766C49.5887 9.84766 50.2449 9.9789 50.6387 10.3727Z",
    fill: "#B9BABE"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4602 10.1102C49.5914 10.1102 49.5914 10.3727 49.7227 10.6351V10.5039H49.5914C49.4602 10.3727 49.3289 10.1102 49.4602 10.1102C49.3289 9.97891 49.3289 9.97891 49.4602 10.1102C49.4602 9.97891 49.4602 9.97891 49.4602 10.1102C49.3289 10.1102 49.4602 9.97891 49.4602 10.1102Z",
    fill: "url(#paint108_linear_9942_107848)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5387 9.97734H48.6699C48.6699 9.97734 48.6699 9.84609 48.6699 9.71484C48.5387 9.71484 48.4074 9.71484 48.4074 9.71484C48.4074 9.71484 48.2762 9.84609 48.5387 9.97734Z",
    fill: "url(#paint109_linear_9942_107848)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6699 9.71758L48.5387 9.45508H48.6699C48.6699 9.45508 48.5387 9.45508 48.4074 9.45508V9.58633V9.71758H48.6699Z",
    fill: "url(#paint110_linear_9942_107848)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4574 10.5039C49.4574 10.5039 49.5887 11.0289 49.7199 11.2914L49.8512 11.4227C49.9824 11.4227 49.9824 11.4227 49.9824 11.5539C49.9824 11.5539 49.7199 11.4227 49.5887 10.8977H49.4574C49.5887 10.7664 49.4574 10.6352 49.4574 10.5039Z",
    fill: "url(#paint111_linear_9942_107848)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1164 11.6836C50.1164 11.6836 49.8539 11.6836 49.5914 11.6836C49.4602 11.6836 49.4602 11.6836 49.4602 11.6836L49.5914 11.8148C49.5914 11.8148 50.1164 11.8148 50.1164 11.6836C50.1164 11.8148 50.2477 11.6836 50.1164 11.6836C50.2477 11.6836 50.2477 11.6836 50.1164 11.6836Z",
    fill: "url(#paint112_linear_9942_107848)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3785 11.1613H51.0348L51.166 11.2926H50.5098V11.5551C50.5098 11.5551 50.5098 11.4238 50.5098 11.6863H50.3785C50.3785 11.6863 50.5098 11.6863 50.5098 11.5551C50.3785 11.5551 50.5098 11.4238 50.3785 11.1613L50.2473 10.8988C50.2473 10.8988 50.2473 10.8988 50.2473 10.7676C50.2473 10.7676 50.3785 10.8988 50.3785 11.1613Z",
    fill: "url(#paint113_linear_9942_107848)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M48.541 9.32311C48.541 9.32311 48.2785 9.19186 48.016 9.06061C47.7535 8.92936 47.2285 8.79812 47.2285 8.92937H47.3598C47.2285 8.79812 48.4098 9.06061 48.541 9.32311Z",
    fill: "#909294"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9324 10.6348C48.9324 10.6348 48.8012 10.6348 48.9324 10.766C48.9324 10.766 48.8012 10.6348 48.9324 10.6348C48.9324 10.766 49.0637 10.766 49.1949 10.8973C49.1949 11.0285 49.3262 11.1598 49.3262 11.291C49.3262 11.4223 49.3262 11.4223 49.3262 11.4223C49.3262 11.4223 49.3262 11.291 49.1949 11.0285C49.0637 10.766 48.9324 10.6348 48.9324 10.6348Z",
    fill: "url(#paint114_linear_9942_107848)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8023 9.84766C48.8023 9.84766 48.8023 10.1102 48.8023 10.2414C48.8023 10.3727 48.9336 10.5039 48.9336 10.5039V10.2414C48.9336 9.97891 48.9336 9.84766 48.8023 9.84766Z",
    fill: "url(#paint115_linear_9942_107848)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6723 9.71484C48.8036 9.84609 48.6723 9.71484 48.6723 9.71484C48.8036 9.71484 48.8036 9.84609 48.9348 9.84609C48.9348 9.97734 48.9348 9.97734 48.9348 9.97734C49.0661 10.1086 48.9348 9.84609 48.6723 9.71484C48.8036 9.84609 48.8036 9.84609 48.6723 9.71484C48.8036 9.84609 48.8036 9.97734 48.8036 10.1086C48.8036 10.1086 48.9348 10.2398 48.9348 10.3711V10.2398V10.3711H48.8036L48.6723 10.2398H48.5411C48.5411 10.2398 48.5411 10.2398 48.6723 10.2398C48.8036 10.2398 48.8036 10.2398 48.8036 10.2398L48.6723 10.1086H48.5411H48.6723C48.6723 10.1086 48.5411 9.97734 48.5411 9.84609C48.5411 9.71484 48.5411 9.84609 48.5411 9.84609L48.6723 9.71484Z",
    fill: "url(#paint116_linear_9942_107848)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8035 10.3711C48.8035 10.3711 48.6723 10.3711 48.8035 10.3711C48.8035 10.6336 48.8035 10.7648 48.8035 10.7648L48.9348 10.8961C48.9348 10.8961 48.8035 10.6336 48.9348 10.6336H49.066L49.1973 10.7648C49.1973 10.8961 48.9348 10.3711 48.8035 10.3711Z",
    fill: "url(#paint117_linear_9942_107848)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6715 10.3711C48.6715 10.3711 48.6715 10.5023 48.6715 10.3711C48.6715 10.5023 48.6715 10.5023 48.6715 10.3711C48.5402 10.3711 48.5402 10.3711 48.5402 10.3711L48.6715 10.5023L48.8027 10.6336C48.8027 10.7648 48.8027 10.6336 48.6715 10.3711Z",
    fill: "url(#paint118_linear_9942_107848)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9336 10.3711C48.9336 10.3711 48.8023 10.3711 48.6711 10.3711C48.6711 10.3711 48.6711 10.3711 48.6711 10.5023C48.6711 10.5023 48.8023 10.3711 48.9336 10.3711Z",
    fill: "#B9BABE"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4074 9.71758C48.4074 9.71758 48.2762 9.71758 48.4074 9.71758C48.2762 9.84882 48.2762 9.84883 48.4074 9.98007L48.5387 10.1113V9.98007L48.6699 10.1113C48.6699 10.1113 48.5387 9.98007 48.4074 9.84882C48.2762 9.71758 48.2762 9.71758 48.4074 9.71758L48.2762 9.58633C48.2762 9.58633 48.1449 9.45508 48.2762 9.45508C48.2762 9.58633 48.4074 9.71758 48.4074 9.71758Z",
    fill: "url(#paint119_linear_9942_107848)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M48.934 9.58594C48.934 9.58594 49.0652 9.71719 49.0652 9.84844C49.0652 9.84844 49.0652 9.84844 49.1965 9.84844C49.3277 9.84844 49.1965 9.84844 49.1965 9.84844L49.3277 9.71719C49.459 9.71719 49.459 9.71719 49.459 9.71719C49.459 9.71719 49.3277 9.71719 49.1965 9.71719C49.1965 9.84844 48.934 9.58594 48.934 9.58594Z",
    fill: "url(#paint120_linear_9942_107848)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7227 9.84766C49.7227 9.84766 49.9852 9.9789 50.1164 10.3727C50.2477 10.7664 50.3789 11.0289 50.3789 11.0289C50.3789 11.0289 50.2477 10.6351 50.1164 10.3727C50.1164 10.3727 49.8539 9.84766 49.7227 9.84766Z",
    fill: "url(#paint121_linear_9942_107848)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5074 11.291H51.1637L51.2949 11.5535H50.5074C50.5074 11.5535 50.5074 11.5535 50.5074 11.291Z",
    fill: "url(#paint122_linear_9942_107848)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0336 10.8984L51.1648 11.2922L51.2961 11.5547H50.5086C50.5086 11.5547 50.5086 11.5547 50.5086 11.6859V11.8172H51.0336H50.5086C50.5086 11.8172 50.9023 11.8172 51.0336 11.8172C51.1648 11.8172 51.5586 11.6859 51.5586 11.6859L51.0336 10.8984Z",
    fill: "#414042"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3789 10.8984V11.0297H51.0352L50.9039 10.8984H50.3789Z",
    fill: "#909294"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2477 10.6348L50.3789 10.8973H51.0352L50.9039 10.6348H50.2477Z",
    fill: "#414042"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4602 10.3711C49.4602 10.3711 49.4602 10.5023 49.4602 10.3711C49.5914 10.3711 49.5914 10.5023 49.5914 10.5023L49.7227 10.8961C49.7227 10.8961 49.7227 10.8961 49.5914 10.8961C49.5914 10.8961 49.5914 10.8961 49.4602 10.7648C49.4602 10.6336 49.3289 10.5023 49.4602 10.3711Z",
    fill: "#414042"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0652 10.3711H49.3277C49.3277 10.3711 49.3277 10.3711 49.3277 10.5023C49.3277 10.5023 49.459 10.7648 49.459 10.8961H49.1965C49.1965 10.8961 49.0652 10.5023 49.0652 10.3711C48.934 10.5023 49.0652 10.5023 49.0652 10.3711C49.0652 10.5023 49.0652 10.5023 49.0652 10.3711C49.0652 10.5023 49.0652 10.3711 49.0652 10.3711Z",
    fill: "#414042"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M49.591 9.97816C49.591 9.97816 49.4598 9.97816 49.4598 10.1094C49.4598 10.2407 49.4598 10.3719 49.4598 10.5032C49.591 10.5032 49.4598 10.1094 49.591 9.97816C49.7223 9.97816 49.7223 9.97816 49.591 9.97816C49.7223 9.97816 49.7223 9.97816 49.591 9.97816C49.7223 9.97816 49.8535 9.97816 49.8535 10.1094C49.8535 10.1094 49.7223 9.84691 49.591 9.97816Z",
    fill: "#E4E4E5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M49.459 9.97734C49.459 10.1086 49.3277 9.97734 49.459 9.97734C49.3277 10.1086 49.459 10.1086 49.459 10.1086C49.459 10.5023 49.5902 10.6336 49.5902 10.6336V10.2398C49.5902 10.1086 49.5902 9.97734 49.459 9.97734L49.7215 10.1086L49.8527 10.2398H49.984V10.1086H50.1152C50.1152 10.1086 50.1152 10.1086 49.984 9.97734C49.8527 9.84609 49.7215 9.71484 49.7215 9.71484C49.5902 9.84609 49.459 9.84609 49.459 9.97734C49.3277 9.84609 49.459 9.84609 49.459 9.97734C49.3277 9.97734 49.3277 9.97734 49.459 9.97734L49.3277 9.84609C49.3277 9.97734 49.3277 9.84609 49.459 9.97734C49.459 9.84609 49.459 9.84609 49.459 9.97734C49.459 9.97734 49.5902 9.84609 49.459 9.97734Z",
    fill: "#414042"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5402 9.97852H48.8027V10.1098H48.6715L48.5402 9.97852Z",
    fill: "#909294"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9348 9.58594L49.1973 9.71719H49.3285C49.4598 9.71719 49.066 9.58594 48.9348 9.58594C49.066 9.58594 49.4598 9.71719 49.4598 9.71719H49.591L49.1973 9.58594L49.591 9.71719H49.7223L49.8535 9.84844H49.591H49.4598C49.4598 9.84844 49.3285 9.84844 49.1973 9.84844L48.9348 9.58594Z",
    fill: "#414042"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M48.541 9.71484H48.4098C48.4098 9.71484 48.2785 9.71484 48.2785 9.84609C48.2785 9.84609 48.2785 9.97734 48.4098 10.1086L48.2785 9.84609C48.4098 9.71484 48.541 9.71484 48.541 9.71484Z",
    fill: "#414042"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5402 9.45508C48.409 9.58633 48.5402 9.71758 48.5402 9.71758C48.6715 9.71758 48.5402 9.58633 48.5402 9.45508H48.6715H48.8027C48.8027 9.45508 48.6715 9.45508 48.5402 9.45508Z",
    fill: "#414042"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2479 11.2922V11.4234H50.3792C50.3792 11.4234 50.5104 11.2922 50.3792 10.8984L50.2479 11.2922C50.2479 11.2922 50.3792 11.4234 50.2479 11.2922Z",
    fill: "#232020"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1148 10.6348C49.9836 10.766 49.9836 10.766 50.1148 10.6348L50.2461 10.8973C50.2461 10.8973 50.2461 10.8973 50.1148 10.6348C50.1148 10.6348 50.2461 10.766 50.1148 10.6348C50.1148 10.766 50.1148 10.6348 50.1148 10.6348C50.1148 10.766 50.1148 10.6348 50.1148 10.6348Z",
    fill: "#232020"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7215 10.5039L49.8527 10.6352V10.7664L50.1152 11.0289L49.984 11.1602L49.8527 10.8977L49.7215 10.5039Z",
    fill: "url(#paint123_linear_9942_107848)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9852 10.3723C50.1164 10.5035 50.3789 10.8973 50.3789 10.8973L50.2477 10.6348C50.1164 10.3723 49.9852 10.1098 49.9852 10.1098H49.8539L49.9852 10.3723C49.8539 10.241 49.8539 10.241 49.8539 10.241L49.7227 10.1098L49.5914 9.97852C49.4602 10.1098 49.5914 10.241 49.5914 10.5035C49.5914 10.766 49.7227 10.8973 49.7227 10.8973L49.8539 11.0285L49.9852 11.291L49.7227 11.0285L49.5914 10.766H49.7227L49.8539 11.0285C49.8539 11.0285 49.8539 11.0285 49.9852 11.0285V10.8973C49.9852 10.8973 49.9852 11.0285 50.1164 10.8973V10.766C50.1164 10.5035 49.9852 10.3723 49.9852 10.3723Z",
    fill: "#E4E4E5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8539 10.8984L50.1164 11.0297L50.2477 11.1609C50.2477 11.1609 50.2477 11.1609 50.2477 11.0297C50.2477 11.0297 50.3789 11.1609 50.3789 11.2922C50.3789 11.2922 50.3789 11.2922 50.3789 11.4234C50.3789 11.4234 50.2477 11.2922 50.2477 11.4234L50.1164 11.2922H49.9852V11.1609L49.8539 10.8984Z",
    fill: "#E4E4E5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9848 11.291C49.9848 11.291 49.9848 11.4223 49.9848 11.291C50.116 11.4223 49.9848 11.4223 49.9848 11.291C49.9848 11.4223 50.116 11.4223 50.2473 11.4223C50.2473 11.4223 50.2473 11.4223 50.3785 11.4223H50.5098H50.3785C50.2473 11.5535 49.9848 11.4223 49.9848 11.291Z",
    fill: "#E4E4E5"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7223 10.5047L49.8535 10.6359L49.7223 10.3734L49.591 10.2422L49.7223 10.5047Z",
    fill: "url(#paint124_linear_9942_107848)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M49.591 10.2426L49.7223 10.3738L49.8535 10.2426L49.7223 10.1113L49.591 10.2426Z",
    fill: "#6D6E71"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3273 11.1602C49.3273 11.1602 49.4586 11.1602 49.5898 11.2914C49.5898 11.1602 49.4586 11.1602 49.3273 11.1602Z",
    fill: "#6D6E71"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3273 11.0273H49.5898C49.5898 11.1586 49.3273 11.0273 49.3273 11.0273Z",
    fill: "#6D6E71"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9836 11.5547C50.1148 11.5547 50.2461 11.6859 50.2461 11.6859L49.9836 11.5547Z",
    fill: "#6D6E71"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9352 9.5835C48.9352 9.5835 48.9352 9.846 49.0664 9.97725C49.0664 9.97725 49.0664 9.97725 49.0664 9.846C48.9352 9.45225 48.9352 9.5835 48.9352 9.5835Z",
    fill: "#EEEEF0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8023 9.58594H48.9336V9.71719H48.8023V9.58594Z",
    fill: "#EEEEF0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8027 9.58477H48.5402C48.5402 9.45352 48.6715 9.45352 48.8027 9.58477H48.6715H48.8027C48.8027 9.58477 48.8027 9.45352 48.8027 9.58477C48.8027 9.45352 48.8027 9.45352 48.8027 9.58477C48.8027 9.58477 48.8027 9.45352 48.8027 9.58477Z",
    fill: "#EEEEF0"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6715 9.71484C48.6715 9.84609 48.6715 10.1086 48.8027 10.2398C48.8027 10.2398 48.6715 9.97734 48.6715 9.71484C48.6715 9.84609 48.6715 9.71484 48.6715 9.71484C48.6715 9.71484 48.8027 9.71484 48.6715 9.71484Z",
    fill: "#232020"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M48.541 9.97852H48.6722V10.1098C48.8035 10.241 48.541 9.97852 48.541 9.97852Z",
    fill: "#414042"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5402 9.71484C48.6715 9.71484 48.5402 9.71484 48.5402 9.71484C48.5402 9.84609 48.6715 9.84609 48.6715 9.84609H48.8027C48.8027 9.84609 48.8027 9.84609 48.8027 9.71484H48.5402Z",
    fill: "#414042"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2461 10.6379C50.1148 10.3754 49.9836 9.98166 49.9836 9.98166C49.9836 9.85041 50.1148 10.3754 50.2461 10.6379Z",
    fill: "#414042"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2461 10.6367C50.1148 10.3742 49.9836 9.98047 49.9836 9.98047C49.9836 9.98047 50.2461 10.3742 50.2461 10.6367Z",
    fill: "#626263"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3789 10.6367C50.2477 10.3742 50.1164 9.98047 50.1164 9.98047C50.1164 9.98047 50.2477 10.3742 50.3789 10.6367Z",
    fill: "#808080"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3789 10.6367C50.2477 10.3742 50.1164 9.98047 50.1164 9.98047C50.1164 9.98047 50.2477 10.3742 50.3789 10.6367Z",
    fill: "#9F9FA1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3789 10.6367C50.2477 10.3742 50.1164 9.98047 50.1164 9.98047C50.1164 9.98047 50.2477 10.3742 50.3789 10.6367Z",
    fill: "#BEBEBF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3789 10.6367C50.2477 10.3742 50.1164 9.98047 50.1164 9.98047C50.1164 9.98047 50.3789 10.3742 50.3789 10.6367Z",
    fill: "#DEDEDE"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3789 10.6367C50.3789 10.3742 50.2477 9.98047 50.2477 9.98047C50.2477 9.98047 50.3789 10.3742 50.3789 10.6367Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2262 9.32227C47.2262 9.32227 47.3574 9.45352 47.4887 9.45352L47.7512 9.71601C47.7512 9.71601 48.1449 9.97851 48.2762 10.1098C48.4074 10.1098 48.5387 10.3723 48.5387 10.3723C48.5387 10.3723 48.5387 10.3723 48.6699 10.3723L48.1449 9.97851L47.6199 9.71601C47.7512 9.71601 47.6199 9.71601 47.6199 9.71601L47.3574 9.58476V9.45352C47.4887 9.32227 47.3574 9.32227 47.2262 9.32227Z",
    fill: "#414042"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7527 9.32266C47.884 9.19141 47.7527 9.32266 47.7527 9.32266C47.884 9.19141 48.0152 9.19141 48.0152 9.19141H48.1465H48.0152C47.884 9.32265 47.7527 9.32266 47.7527 9.32266Z",
    fill: "#414042"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3574 8.92969C47.4887 8.92969 47.7512 9.06094 47.7512 9.06094H48.0137L47.3574 8.92969Z",
    fill: "#414042"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9324 10.6348C48.9324 10.6348 48.9324 10.766 48.9324 10.8973C48.9324 11.0285 49.1949 11.1598 49.1949 11.1598L49.3262 11.291C49.3262 11.291 49.3262 11.1598 49.3262 11.0285C49.1949 10.8973 49.0637 10.6348 48.9324 10.6348Z",
    fill: "#D2D2D2"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8512 10.2422L49.9824 10.5047V10.3734C49.9824 10.5047 49.8512 10.2422 49.8512 10.2422Z",
    fill: "#6D6E71"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M48.803 9.84766C48.803 9.84766 48.803 9.9789 48.803 9.84766C48.803 9.9789 48.803 9.9789 48.803 9.84766V9.9789C48.803 9.9789 48.9342 9.9789 48.803 9.84766C48.803 9.84766 48.9342 9.84766 48.803 9.84766Z",
    fill: "#6D6E71"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6402 10.6352V10.5039C50.7715 10.5039 50.7715 10.5039 50.9027 10.6352C51.034 10.6352 51.2965 11.2914 51.4277 11.8164L50.7715 10.7664L50.6402 10.6352Z",
    fill: "url(#paint125_linear_9942_107848)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4598 11.4238C49.4598 11.4238 49.591 11.4238 49.7223 11.4238C49.7223 11.4238 49.8535 11.4238 49.8535 11.5551C49.8535 11.5551 49.591 11.4238 49.4598 11.4238Z",
    fill: "#414042"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M49.591 11.4238C49.591 11.4238 49.7223 11.5551 49.8535 11.5551C49.8535 11.5551 49.7223 11.4238 49.591 11.4238Z",
    fill: "#414042"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8523 11.0273L49.9836 11.2898H50.1148L50.2461 11.4211V11.2898H50.1148H49.9836L49.8523 11.0273Z",
    fill: "#414042"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6914 11.8148L50.9039 11.6836C50.9039 11.6836 49.8539 11.9461 49.7227 11.8148C49.4602 11.8148 50.1164 12.0773 51.6914 11.8148Z",
    fill: "url(#paint126_linear_9942_107848)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9043 11.6832C50.9043 11.6832 50.7731 10.7645 50.6418 10.6332C50.6418 10.502 50.6418 10.502 50.6418 10.502H50.9043C50.9043 10.502 51.5605 11.2894 51.5605 11.8144L50.9043 11.6832Z",
    fill: "url(#paint127_linear_9942_107848)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3332 16.2776C36.2019 16.2776 18.2208 16.0151 17.3021 16.0151C16.6458 16.0151 15.9896 15.6214 15.5958 15.0964C15.5958 15.0964 15.4646 14.8339 15.4646 14.7026C15.2021 13.9151 14.6771 12.4714 13.3646 11.1589C11.3958 9.19018 11.2646 8.79643 11.2646 8.53393C11.2646 8.27143 11.6583 6.17145 11.6583 6.0402L13.3646 1.05273L11.6583 6.0402C11.6583 6.0402 11.1333 8.27143 11.2646 8.53393C11.2646 8.79643 11.2646 9.19018 13.3646 11.1589C14.6771 12.4714 15.2021 14.0464 15.4646 14.8339C15.5958 15.0964 15.5958 15.2276 15.5958 15.2276C15.8583 15.6214 16.3833 16.1464 17.1708 16.1464C18.2208 15.8839 36.0707 16.1464 36.3332 16.2776C36.3332 16.2776 36.7269 16.1464 36.7269 15.7526C36.7269 15.2276 37.3832 10.8964 36.9894 9.32143C36.7269 7.87769 36.4644 7.35269 36.4644 7.35269L35.8082 4.72771L36.4644 7.35269C36.4644 7.35269 36.8582 7.87769 36.9894 9.32143C37.2519 10.8964 36.7269 15.3589 36.7269 15.7526C36.7269 16.1464 36.3332 16.2776 36.3332 16.2776Z",
    fill: "#232020"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80273 11.5523C6.80273 11.5523 6.67148 11.2898 6.54024 11.1586C6.40899 11.0273 6.40899 11.0273 6.40899 11.0273C6.40899 11.0273 4.70276 10.8961 4.30901 10.8961C4.04651 10.8961 3.78401 10.5023 3.78401 10.5023L2.47152 8.40234L3.78401 10.5023C3.78401 10.5023 3.91526 10.8961 4.17776 10.8961C4.44026 10.8961 6.27774 11.0273 6.27774 11.0273C6.27774 11.0273 6.40899 11.0273 6.40899 11.1586C6.67149 11.2898 6.80273 11.5523 6.80273 11.5523Z",
    fill: "#232020"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9649 13.3887H46.3086H46.9649L49.5898 12.0762L46.9649 13.3887Z",
    fill: "#232020"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8359 9.32225C46.8359 9.32225 44.8672 8.14101 41.9797 7.35352C44.8672 8.14101 46.8359 9.32225 46.8359 9.32225Z",
    fill: "#232020"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M24.916 16.0159V14.7034C24.916 14.7034 24.7848 10.8972 24.6535 9.45346C24.5223 8.00972 24.1285 6.56598 24.1285 6.56598L23.4723 0.791016L24.1285 6.56598C24.1285 6.56598 24.5223 8.00972 24.6535 9.45346C24.7848 10.8972 24.916 14.5722 24.916 14.7034V16.0159Z",
    fill: "#232020"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91703 5.38256C3.91703 5.38256 4.31078 3.41382 5.75452 2.23258C5.75452 2.23258 8.11701 0.526343 22.2919 0.657592C22.2919 0.657592 28.3294 0.657592 32.2668 2.62633C35.4168 4.07007 37.6481 5.25131 39.748 7.22005L36.5981 7.0888L24.2607 6.43255L12.1857 5.77631L3.91703 5.38256Z",
    fill: "url(#paint128_linear_9942_107848)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M4.17909 5.25131C4.17909 5.25131 5.88533 3.93882 10.0853 3.54508C12.9728 3.28258 18.6165 2.62633 22.4227 2.49508C22.4227 2.49508 31.2164 2.88883 32.0039 3.02008C32.0039 3.02008 29.1164 1.31384 24.2602 1.05134C19.404 0.657597 15.5978 1.05134 11.7915 1.31384C7.98531 1.57634 5.88533 2.23258 5.62283 2.62633C5.49158 2.75758 4.17909 4.46382 4.17909 5.25131Z",
    fill: "url(#paint129_linear_9942_107848)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M39.748 7.3513L36.5981 7.22005L24.2607 6.5638L12.1857 5.90756L3.91703 5.38256C3.91703 5.38256 4.31078 3.41382 5.75452 2.23258C5.75452 2.23258 8.11701 0.526343 22.2919 0.657592C22.2919 0.657592 28.3294 0.657592 32.2668 2.62633C35.5481 4.20132 37.7793 5.38256 39.748 7.3513ZM39.0918 6.95755C37.1231 5.25131 34.8918 4.07007 31.8731 2.75758C28.0669 0.920091 22.1607 0.920091 22.1607 0.920091C8.37951 0.788842 6.01702 2.36383 6.01702 2.36383C4.57328 3.41383 4.17953 5.25131 4.17953 5.25131L12.317 5.64506L23.9982 6.30131L35.9418 6.95755H39.0918Z",
    fill: "#59595B"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7617 1.18359L11.9242 5.90856L3.91805 5.51481C4.57429 3.28358 5.62429 2.49609 5.75554 2.36484C6.28053 1.97109 7.72427 1.83984 7.72427 1.83984C11.0055 1.18359 13.7617 1.18359 13.7617 1.18359ZM6.80553 2.23359C6.67428 2.23359 6.01803 2.36484 5.75554 2.75858C5.36179 3.15233 4.57429 3.93983 4.57429 4.72732C4.57429 4.72732 4.70555 4.72732 4.70555 4.85857C4.70555 4.85857 5.75554 5.12107 6.01803 4.85857C6.01803 4.85857 5.75554 4.07107 6.41178 3.28358C6.41178 3.28358 6.67428 3.15233 6.80553 3.15233L7.33052 2.36484C7.46177 2.23359 6.93677 2.23359 6.80553 2.23359ZM12.318 1.97109C11.6617 1.97109 9.16801 2.49608 8.90551 2.62733C8.64301 2.62733 8.24927 3.41483 8.24927 3.41483C8.24927 3.41483 8.51177 3.41483 8.90551 3.67733C9.29926 3.93983 9.16801 4.98982 9.16801 4.98982C9.29925 4.98982 11.268 5.12107 11.268 5.12107L12.318 1.97109Z",
    fill: "#232020"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 6.30117L12.8427 5.77617L13.1052 4.85743C13.1052 4.85743 13.3677 4.85742 13.4989 4.59493C13.6302 4.33243 14.2864 1.8387 14.2864 1.70745C14.2864 1.5762 14.0239 1.70745 14.0239 1.70745L14.2864 0.919952C14.2864 0.919952 22.0301 0.657454 23.0801 0.788703L23.6051 3.67618L23.7363 5.90742V6.30117ZM23.3426 5.90742L23.0801 1.44495C23.0801 1.44495 16.9114 1.44495 16.2551 1.5762L15.8614 3.28244C15.8614 3.28244 16.2551 3.15119 16.3864 3.28244C16.3864 3.28244 16.5176 3.15119 16.6489 3.28244C16.7801 3.28244 17.3051 3.41368 17.3051 3.80743C17.4364 4.20118 17.4364 4.72618 17.3051 4.98868C17.3051 4.98868 17.4364 5.11992 17.5676 5.25117L17.6989 5.77617L23.3426 5.90742Z",
    fill: "#232020"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7305 7.21949L25.0493 6.56324L24.7868 6.03825L24.1306 1.05078C26.3618 1.05078 30.168 2.10077 31.8743 2.75702C33.5805 3.41326 36.0742 4.98825 36.0742 4.98825L36.7305 7.21949ZM32.6617 3.67576L30.4305 2.62577C30.4305 2.62577 30.2993 2.75702 30.168 2.75702C30.0368 2.75702 30.0368 2.62577 30.0368 2.62577C30.0368 2.62577 27.8055 1.83828 27.2805 1.70703C25.7055 1.44453 24.6556 1.44453 24.6556 1.44453L24.9181 2.75702C24.9181 2.75702 25.1805 2.88827 25.3118 3.15076C25.443 3.41326 25.5743 4.06951 25.3118 4.46326C25.3118 4.5945 25.3118 4.857 25.3118 4.857C25.3118 4.857 25.443 5.1195 25.5743 5.51325C25.7055 5.907 25.7055 6.03825 25.7055 6.03825L31.743 6.30074C31.743 6.30074 31.6118 5.6445 31.8743 5.382C32.1367 5.1195 32.6617 5.1195 32.793 5.1195C32.9242 5.25075 32.6617 3.67576 32.6617 3.67576ZM33.9742 5.51325L33.7117 4.20076C33.7117 4.20076 33.0555 3.93826 32.9242 3.80701L33.1867 5.1195C33.1867 5.1195 33.318 4.98825 33.4492 4.98825C33.5805 5.1195 33.5805 5.1195 33.4492 5.382L33.5805 5.51325C33.7117 5.6445 33.843 5.51325 33.9742 5.51325ZM34.4992 5.6445L34.368 4.46326C34.368 4.46326 34.2367 4.33201 34.1055 4.33201L34.368 5.51325L34.4992 5.6445Z",
    fill: "#232020"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M39.748 7.3513L36.5981 7.22005L24.2607 6.5638L12.1857 5.90756L3.91703 5.38256C3.91703 5.38256 4.31078 3.41382 5.75452 2.23258C5.75452 2.23258 8.11701 0.526343 22.2919 0.657592C22.2919 0.657592 28.3294 0.657592 32.2668 2.62633C35.5481 4.20132 37.7793 5.38256 39.748 7.3513ZM39.0918 7.0888C37.1231 5.38256 34.8918 4.20132 31.8731 2.88883C28.0669 1.05134 22.1607 1.05134 22.1607 1.05134C8.37951 0.788843 6.01702 2.36383 6.01702 2.36383C4.57328 3.41383 4.17953 5.25131 4.17953 5.25131L12.317 5.64506L23.9982 6.30131L35.9418 6.95755L39.0918 7.0888Z",
    fill: "#414042"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5301 5.90673C11.5301 5.90673 12.9738 1.44427 13.2363 1.05052C13.2363 1.05052 14.4176 0.919271 14.5488 1.05052L12.9738 6.03798L11.5301 5.90673Z",
    fill: "url(#paint130_linear_9942_107848)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0789 0.791016L23.4727 6.43473L25.4414 6.69722C25.4414 6.69722 24.5227 1.05351 24.5227 0.922265C24.3914 0.922265 23.3414 0.791016 23.0789 0.791016Z",
    fill: "url(#paint131_linear_9942_107848)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7743 1.31328C29.7743 1.31328 30.1681 1.18203 30.4306 1.05078C30.4306 1.05078 31.218 1.44453 32.5305 1.96952C35.0243 3.01952 39.093 4.72576 41.718 6.30075C41.718 6.30075 42.1117 6.43199 41.3242 6.82574C38.6992 5.51325 36.0743 3.41326 29.7743 1.31328Z",
    fill: "#373535"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6118 1.70703C31.6118 1.70703 36.5992 3.67576 39.2242 5.382L41.3242 6.1695C41.3242 6.1695 37.1242 3.67576 31.0868 1.44453L30.4305 1.05078C30.4305 1.05078 31.4805 1.57578 31.6118 1.70703Z",
    fill: "url(#paint132_linear_9942_107848)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3356 4.98828L36.7293 6.95702H39.0918C39.0918 7.08827 38.1731 6.16952 36.3356 4.98828Z",
    fill: "#232020"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5488 4.46484L36.2051 7.22108H36.8613L36.3363 4.85859C36.3363 4.85859 35.8113 4.46484 35.5488 4.46484Z",
    fill: "url(#paint133_linear_9942_107848)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4653 5.12109L36.859 6.95858H38.959C38.959 6.95858 38.1715 6.17109 36.4653 5.12109Z",
    fill: "url(#paint134_radial_9942_107848)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4492 5.90742C33.4492 6.03867 33.318 6.16992 33.318 6.82616C33.4492 6.82616 33.4492 6.03867 33.4492 5.90742C33.7117 5.64492 33.9742 5.51367 34.1055 5.51367C34.1055 5.51367 33.7117 5.64492 33.4492 5.90742Z",
    fill: "#232020"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9714 5.51367C33.8401 5.51367 33.3151 5.77617 33.3151 6.03867C33.3151 6.30117 33.1839 6.95741 33.1839 7.08866C33.1839 7.21991 33.1839 7.21991 33.4464 7.21991C33.5776 7.21991 34.2339 7.35116 34.3651 7.35116C34.4964 7.35116 34.3651 7.35116 34.4964 7.48241C34.4964 7.61366 34.4964 7.87616 34.4964 7.87616C34.6276 7.87616 34.8901 8.13865 35.8089 7.74491C35.9401 7.61366 35.8089 7.48241 35.8089 7.35116L35.2839 6.82616V6.69491C35.2839 6.69491 35.4151 6.30117 35.1526 6.03867C34.8901 5.90742 34.4964 5.64492 33.9714 5.51367Z",
    fill: "url(#paint135_linear_9942_107848)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9715 6.03984L34.3652 6.17109C34.4965 6.30234 34.6277 6.43359 34.6277 6.69609C34.6277 6.95859 34.3652 6.95859 34.3652 6.95859V7.08984H34.234L33.9715 7.22109C33.9715 7.22109 33.5777 7.35233 33.4465 7.22109C33.4465 7.22109 33.184 7.22108 33.184 7.08984C33.184 7.08984 33.184 6.95859 33.3152 6.03984L33.4465 5.77734C33.4465 5.77734 33.5777 5.77734 33.709 5.77734H34.1027C34.234 5.77734 34.759 5.90859 35.0215 6.17109C35.0215 6.17109 34.759 6.03984 34.3652 6.03984C33.9715 5.90859 33.9715 5.90859 33.9715 6.03984Z",
    fill: "url(#paint136_linear_9942_107848)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1535 6.82563H34.891L35.0223 6.69438H34.7598C34.7598 6.69438 35.0223 6.43188 35.1535 6.30063C35.1535 6.16938 35.1535 6.03813 35.0223 6.03813C35.0223 5.90689 35.1535 6.30063 35.0223 6.43188C34.891 6.56313 34.6285 6.69438 34.6285 6.69438L34.4973 6.82563C34.4973 6.82563 34.4973 6.82563 34.366 6.82563V6.95688H34.2348C34.2348 6.95688 34.2348 6.95688 34.1035 7.08813C33.9723 7.21938 33.7098 7.21938 33.7098 7.21938C33.7098 7.21938 34.4973 7.21938 34.6285 7.21938C34.7598 7.21938 34.891 7.08813 34.891 7.08813H35.0223C35.1535 7.08813 35.2848 6.95688 35.1535 6.82563C35.2848 6.95688 35.2848 6.82563 35.1535 6.82563Z",
    fill: "url(#paint137_linear_9942_107848)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4965 7.48242L34.3652 7.61367V7.74491C34.3652 7.74491 34.3652 7.87616 34.4965 7.87616C34.6277 7.87616 35.0215 7.87616 35.5465 7.74491C35.5465 7.74491 35.6777 7.74492 35.6777 7.61367C35.6777 7.48242 35.6777 7.35117 35.6777 7.35117L35.284 6.82617V6.95742C35.284 6.95742 35.4152 7.08867 35.284 7.08867C35.284 7.21992 35.0215 7.48242 34.4965 7.48242Z",
    fill: "url(#paint138_linear_9942_107848)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3664 7.35117C34.3664 7.35117 34.7602 7.35117 34.8914 7.21992C35.0227 7.21992 35.2852 7.08867 35.2852 6.82617C35.2852 6.82617 35.2852 6.95742 35.1539 7.08867C35.0227 7.21992 34.7602 7.35117 34.6289 7.35117C34.6289 7.48242 34.3664 7.35117 34.3664 7.35117Z",
    fill: "#1F191A"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4473 6.03828C33.4473 6.16953 33.316 6.30078 33.316 6.95702L33.4473 6.03828C33.7098 5.77578 33.9723 5.64453 34.1035 5.64453C34.1035 5.64453 33.7098 5.64453 33.4473 6.03828Z",
    fill: "#232020"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8904 6.82617V7.08867C34.8904 7.08867 34.7591 7.35117 34.2341 7.35117C34.2341 7.35117 34.4966 7.35117 34.7591 7.21992C35.0216 7.08867 35.0216 6.95742 34.8904 6.82617C34.8904 6.82617 35.0216 6.82617 34.8904 6.82617Z",
    fill: "#BFBFBF"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3149 7.21875H33.4461C33.4461 7.21875 33.4461 7.21875 33.7086 7.35C33.8398 7.35 34.1023 7.35 34.2336 7.35C34.3648 7.35 34.4961 7.35 34.4961 7.35C34.4961 7.35 34.2336 7.35 33.9711 7.35C33.7086 7.35 33.7086 7.35 33.7086 7.35C33.7086 7.35 33.3149 7.35 33.3149 7.21875Z",
    fill: "url(#paint139_linear_9942_107848)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2842 6.95703C35.2842 7.08828 35.2842 7.08828 35.2842 6.95703C35.2842 7.08828 35.2842 7.08828 35.2842 7.21953L35.678 7.74452C35.678 7.74452 35.8092 7.61328 35.678 7.48203C35.678 7.35078 35.4155 6.95703 35.2842 6.95703Z",
    fill: "url(#paint140_linear_9942_107848)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M52.084 13.7839C52.084 13.9151 51.9527 14.0464 51.9527 14.0464C51.9527 14.0464 51.9527 14.0464 51.9527 14.1776C51.9527 14.3089 51.8215 14.3089 51.8215 14.3089C51.8215 14.3089 51.6902 15.3589 51.6902 15.4901H51.8215C51.8215 15.4901 51.9527 14.5714 51.9527 14.3089C52.084 14.0464 52.084 13.6526 52.084 13.7839Z",
    fill: "#E4E4E5"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6391 14.5699C50.6391 14.7012 51.0328 14.7012 51.2953 14.5699C51.5578 14.4387 51.6891 14.4387 51.6891 14.3074C51.6891 14.3074 51.8203 14.1762 51.8203 14.0449C51.8203 14.0449 51.4266 14.3074 51.1641 14.4387C50.7703 14.5699 50.6391 14.5699 50.6391 14.5699Z",
    fill: "#B9BABE"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9016 14.5695C50.9016 14.5695 50.9016 14.7008 50.9016 14.5695C50.9016 14.7008 51.2953 14.5695 51.5578 14.4383C51.5578 14.4383 51.6891 14.307 51.8203 14.307V14.1758C51.8203 14.1758 51.4266 14.4383 50.9016 14.5695Z",
    fill: "url(#paint141_linear_9942_107848)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4289 15.6211C50.5102 15.8836 50.3789 15.8836 50.3789 15.8836C50.5102 16.0148 51.5602 15.6211 51.4289 15.6211C51.5602 15.6211 51.5602 15.6211 51.6914 15.6211H51.4289C51.5602 15.6211 51.5602 15.6211 51.4289 15.6211Z",
    fill: "#232020"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2977 14.5711C51.2977 14.5711 51.2977 14.7023 51.2977 14.5711L51.5602 14.9648C51.5602 14.9648 51.6914 14.7023 51.6914 14.4398C51.6914 14.3086 51.6914 14.3086 51.6914 14.3086L51.2977 14.5711Z",
    fill: "#414042"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5599 15.4914C51.6912 15.4914 51.4287 15.6227 51.2974 15.6227H51.1662C51.1662 15.6227 51.2974 15.4914 51.2974 15.3602C51.2974 15.2289 51.2974 15.4914 51.2974 15.3602C51.4287 15.4914 51.4287 15.4914 51.5599 15.4914Z",
    fill: "#414042"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2965 14.7012C51.2965 14.7012 51.2965 14.8324 51.2965 14.9637C51.2965 15.0949 51.2965 15.2262 51.2965 15.3574V15.2262H51.4277C51.4277 15.2262 51.4277 15.0949 51.4277 14.9637C51.4277 14.9637 51.4277 14.8324 51.2965 14.7012C51.4277 14.8324 51.4277 14.7012 51.2965 14.7012C51.2965 14.9637 51.2965 14.8324 51.2965 14.7012Z",
    fill: "#414042"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6906 14.4392C51.6906 14.4392 51.5594 14.5704 51.6906 14.4392C51.8219 14.3079 51.8219 14.4392 51.6906 14.4392Z",
    fill: "#414042"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0344 15.2269C51.0344 15.2269 51.0344 15.3582 51.0344 15.4894C51.0344 15.6207 51.0344 15.6207 51.1656 15.6207H51.2969C51.2969 15.6207 51.2969 15.4894 51.2969 15.3582C51.2969 15.2269 51.2969 15.0957 51.2969 15.0957V15.3582C51.2969 15.3582 51.2969 15.3582 51.2969 15.2269H51.0344Z",
    fill: "#EEEEF0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1656 14.8348C51.2969 14.8348 51.2969 14.966 51.2969 15.0973L51.1656 14.8348C51.1656 14.7035 51.1656 14.7035 51.1656 14.8348Z",
    fill: "#EEEEF0"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0344 14.9648L51.2969 15.0961C51.2969 15.0961 51.2969 15.0961 51.2969 15.2273C51.2969 15.2273 51.2969 15.2273 51.2969 15.0961C51.2969 14.9648 51.2969 14.9648 51.2969 14.9648V15.0961V14.9648H51.0344Z",
    fill: "#232020"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43789 1.97461C4.43789 1.97461 4.83164 2.23711 4.96289 2.23711C4.96289 2.23711 4.17539 2.76211 3.78164 3.68085C3.25664 4.86209 3.12539 5.25584 2.86289 6.43708L2.46914 8.40581C2.46914 8.40581 1.94414 8.40581 1.81289 8.40581C1.81289 8.40581 2.20664 6.17458 2.46914 4.99334C2.86289 3.8121 3.78164 2.36836 4.43789 1.97461Z",
    fill: "#EB5757"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83398 2.36601C4.83398 2.36601 4.57149 2.23476 4.30899 2.10352C4.30899 2.10352 4.70274 2.36601 4.83398 2.36601Z",
    fill: "#161B1F"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70117 2.36601C4.70117 2.36601 4.43867 2.23476 4.17617 2.10352C4.30742 2.10352 4.70117 2.36601 4.70117 2.36601Z",
    fill: "#C8C8C8"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70117 2.49882C4.70117 2.49882 4.43867 2.36758 4.17617 2.23633L4.70117 2.49882Z",
    fill: "#10171F"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57031 2.49882C4.57031 2.49882 4.30782 2.36758 4.04532 2.23633C4.17657 2.23633 4.57031 2.49882 4.57031 2.49882Z",
    fill: "#B2B2C8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57031 2.62968C4.57031 2.62968 4.30782 2.49844 4.04532 2.36719L4.57031 2.62968Z",
    fill: "#A3B2C8"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44141 2.62968C4.44141 2.62968 4.17891 2.49844 3.91641 2.36719C4.04766 2.36719 4.44141 2.62968 4.44141 2.62968Z",
    fill: "#CAABC7"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44141 2.75859C4.44141 2.75859 4.17891 2.62734 4.04766 2.49609C4.04766 2.49609 4.44141 2.62734 4.44141 2.75859Z",
    fill: "#2A2930"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30859 2.75859C4.30859 2.75859 4.04609 2.62734 3.91484 2.49609L4.30859 2.75859Z",
    fill: "#BAADC6"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30859 2.75859C4.30859 2.75859 4.04609 2.62734 3.91484 2.49609C3.91484 2.62734 4.30859 2.75859 4.30859 2.75859Z",
    fill: "#A6B8C6"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17773 2.89141C4.17773 2.89141 3.91524 2.76016 3.65275 2.62891C3.78399 2.62891 4.17773 2.89141 4.17773 2.89141Z",
    fill: "#CCAFB8"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17773 3.02227C4.17773 3.02227 3.91524 2.89101 3.65275 2.75977C3.78399 2.75977 4.17773 2.89102 4.17773 3.02227Z",
    fill: "#ACB3C5"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17773 3.02227C4.17773 3.02227 3.91524 2.89101 3.65275 2.75977C3.78399 2.89101 4.17773 3.02227 4.17773 3.02227Z",
    fill: "#0F181F"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04492 3.02227C4.04492 3.02227 3.78243 2.89101 3.65118 2.75977C3.65118 2.89101 4.04492 3.02227 4.04492 3.02227Z",
    fill: "#CBAEAE"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04492 3.15507C4.04492 3.15507 3.78242 3.02383 3.51993 2.89258C3.65118 3.02383 4.04492 3.15507 4.04492 3.15507Z",
    fill: "#E03243"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 3.15507C3.91406 3.15507 3.65157 3.02383 3.38907 2.89258C3.65157 3.02383 3.91406 3.15507 3.91406 3.15507Z",
    fill: "#E03445"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 3.28593C3.91406 3.28593 3.65157 3.15469 3.38907 3.02344C3.65157 3.15469 3.91406 3.28593 3.91406 3.28593Z",
    fill: "#DF3547"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91406 3.41484C3.91406 3.41484 3.65157 3.28359 3.38907 3.15234C3.78282 3.28359 3.91406 3.28359 3.91406 3.41484Z",
    fill: "#DF3649"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78516 3.41484L3.26016 3.15234C3.78515 3.41484 3.78516 3.41484 3.78516 3.41484Z",
    fill: "#DD374A"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78516 3.54766L3.26016 3.28516C3.78515 3.41641 3.78516 3.41641 3.78516 3.54766Z",
    fill: "#DD394C"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78516 3.54766L3.26016 3.28516L3.78516 3.54766Z",
    fill: "#DC3B4F"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78516 3.67851L3.26016 3.41602L3.78516 3.67851Z",
    fill: "#DB394E"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65234 3.67851L3.12735 3.41602L3.65234 3.67851Z",
    fill: "#D9384B"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65234 3.81133L3.12735 3.54883L3.65234 3.81133Z",
    fill: "#D8364A"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65234 3.81133L3.12735 3.54883L3.65234 3.81133Z",
    fill: "#D63548"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65234 3.94218L3.12735 3.67969L3.65234 3.94218Z",
    fill: "#D43447"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52148 3.94218L2.99649 3.67969L3.52148 3.94218Z",
    fill: "#D33345"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52148 4.07109L2.99649 3.80859L3.52148 4.07109Z",
    fill: "#D13244"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52148 4.07109L2.99649 3.80859L3.52148 4.07109Z",
    fill: "#D03042"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52148 4.20352L2.99649 4.07227L3.52148 4.20352Z",
    fill: "#CE2E41"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38867 4.33477L2.86368 4.07227L3.38867 4.33477Z",
    fill: "#CD2D3E"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38867 4.33477L2.86368 4.07227L3.38867 4.33477Z",
    fill: "#CB2C3D"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38867 4.46757L2.86368 4.20508L3.38867 4.46757Z",
    fill: "#C92B3B"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38867 4.46718L2.86368 4.33594L3.38867 4.46718Z",
    fill: "#C82A3A"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25781 4.59843L2.73282 4.33594L3.25781 4.59843Z",
    fill: "#C72838"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25781 4.59843L2.73282 4.33594L3.25781 4.59843Z",
    fill: "#C52737"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25781 4.72734L2.73282 4.46484L3.25781 4.72734Z",
    fill: "#9094A9"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25781 4.72891L2.73282 4.59766L3.25781 4.72891Z",
    fill: "#AE94A8"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25781 4.85976L2.73282 4.72852L3.25781 4.85976Z",
    fill: "#182227"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25781 4.99101L2.60157 4.72852L3.25781 4.99101Z",
    fill: "#9E92A5"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 4.99101L2.47266 4.72852L3.12891 4.99101Z",
    fill: "#1A2930"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 5.12382L2.47266 4.86133L3.12891 5.12382Z",
    fill: "#869AA2"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 5.12382L2.47266 4.86133L3.12891 5.12382Z",
    fill: "#A48B8B"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 5.25468L2.47266 4.99219L3.12891 5.25468Z",
    fill: "#7E939A"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 5.25468L2.47266 4.99219L3.12891 5.25468Z",
    fill: "#AD1B29"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 5.38359L2.47266 5.12109L3.12891 5.38359Z",
    fill: "#24242A"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 5.5164L2.33984 5.25391L2.99609 5.5164Z",
    fill: "#957988"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 5.5164L2.33984 5.25391L2.99609 5.5164Z",
    fill: "#A11725"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 5.64727L2.33984 5.38477L2.99609 5.64727Z",
    fill: "#9C1624"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 5.78008L2.33984 5.51758L2.99609 5.78008Z",
    fill: "#971423"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 5.78008L2.33984 5.51758L2.99609 5.78008Z",
    fill: "#941321"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 5.91093L2.33984 5.64844L2.99609 5.91093Z",
    fill: "#8F1220"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 6.04141L2.33984 5.91016L2.99609 6.04141Z",
    fill: "#8A111E"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86523 5.90859L2.20899 5.77734L2.86523 5.90859Z",
    fill: "#86101D"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86523 6.04141L2.20899 5.91016L2.86523 6.04141Z",
    fill: "#810E1C"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86523 6.04141L2.20899 5.91016L2.86523 6.04141Z",
    fill: "#7E0D1B"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86523 6.30508L2.20899 6.17383L2.86523 6.30508Z",
    fill: "#7A0C19"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86523 6.43593L2.20899 6.30469L2.86523 6.43593Z",
    fill: "#760A18"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86523 6.43593L2.20899 6.30469L2.86523 6.43593Z",
    fill: "#710917"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86523 6.56484L2.20899 6.43359L2.86523 6.56484Z",
    fill: "#6C0715"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86523 6.69766L2.20899 6.56641L2.86523 6.69766Z",
    fill: "#680614"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73242 6.82851C2.73242 6.82851 2.20743 6.69727 2.07618 6.69727C2.33868 6.69727 2.73242 6.82851 2.73242 6.82851Z",
    fill: "#5B0612"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73242 6.96133L2.07618 6.83008C2.20743 6.83008 2.73242 6.96133 2.73242 6.96133Z",
    fill: "#590612"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73242 6.96133L2.07618 6.83008C2.33868 6.96133 2.73242 6.96133 2.73242 6.96133Z",
    fill: "#560714"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73242 7.09219C2.60117 7.09219 2.07618 6.96094 2.07618 6.96094C2.20743 6.96094 2.73242 7.09219 2.73242 7.09219Z",
    fill: "#540A13"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73242 7.09219C2.60117 7.09219 2.07618 6.96094 2.07618 6.96094C2.20743 7.09219 2.60117 7.09219 2.73242 7.09219Z",
    fill: "#510B15"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60182 7.22109C2.47058 7.22109 1.94559 7.08984 1.94559 7.08984C2.20808 7.08984 2.60182 7.22109 2.60182 7.22109C2.60182 7.22109 2.73307 7.22109 2.60182 7.22109Z",
    fill: "#4F0C16"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60156 7.22109C2.47031 7.22109 1.94532 7.08984 1.94532 7.08984C1.94532 7.22109 2.60156 7.22109 2.60156 7.22109Z",
    fill: "#4C0D16"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60156 7.35391C2.47031 7.35391 1.94532 7.22266 1.94532 7.22266L2.60156 7.35391Z",
    fill: "#490E17"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60156 7.48477C2.47031 7.48477 1.94532 7.35352 1.94532 7.35352L2.60156 7.48477Z",
    fill: "#471018"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60156 7.48477C2.47031 7.48477 1.94532 7.35352 1.94532 7.35352C1.94532 7.35352 2.47031 7.48477 2.60156 7.48477Z",
    fill: "#441118"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60156 7.61758C2.47031 7.61758 1.94532 7.48633 1.94532 7.48633C1.94532 7.48633 2.47031 7.61758 2.60156 7.61758Z",
    fill: "#411319"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46992 7.61758C2.33867 7.61758 1.81368 7.48633 1.81368 7.48633C1.94493 7.61758 2.46992 7.61758 2.46992 7.61758C2.60117 7.61758 2.60117 7.61758 2.46992 7.61758Z",
    fill: "#3F1419"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47292 7.74844C2.34167 7.74844 1.94792 7.61719 1.81667 7.61719C1.94792 7.61719 2.47292 7.74844 2.47292 7.74844C2.47292 7.74844 2.60417 7.74844 2.47292 7.74844Z",
    fill: "#3C161A"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47266 7.74844C2.34141 7.74844 1.94766 7.74844 1.81641 7.61719C1.94766 7.74844 2.47266 7.87969 2.47266 7.74844Z",
    fill: "#39171B"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47266 7.87734C2.34141 7.87734 1.94766 7.87734 1.94766 7.74609L2.47266 7.87734Z",
    fill: "#36181B"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47266 8.0095C2.34141 8.0095 1.94766 8.0095 1.94766 8.0095C1.81642 7.87826 2.34141 8.0095 2.47266 8.0095Z",
    fill: "#33191D"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33906 8.14232C2.20782 8.14232 1.81407 8.14232 1.81407 8.14232C1.81407 8.01107 2.33906 8.14232 2.33906 8.14232C2.47031 8.14232 2.47031 8.14232 2.33906 8.14232Z",
    fill: "#2D1C1E"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34011 8.27318C2.20886 8.27318 1.81511 8.27318 1.81511 8.27318C1.81511 8.14193 2.34011 8.27318 2.34011 8.27318C2.34011 8.27318 2.47135 8.27318 2.34011 8.27318Z",
    fill: "#261F1F"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34011 8.27344C2.07761 8.27344 1.81511 8.27344 1.81511 8.27344C1.81511 8.27344 2.34011 8.40469 2.34011 8.27344C2.34011 8.27344 2.47135 8.27344 2.34011 8.27344Z",
    fill: "#232020"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4715 8.40464C2.4715 8.27339 2.60275 7.2234 3.12775 5.12342C3.78399 3.02343 4.83398 2.36719 4.83398 2.36719C4.83398 2.36719 3.65274 3.02343 3.12775 5.12342C2.60275 7.2234 2.4715 8.27339 2.4715 8.40464Z",
    fill: "#EB5757"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4715 8.40699C2.4715 8.40699 2.60275 7.0945 3.12775 4.99451C3.78399 2.89453 4.83398 2.23828 4.83398 2.23828C4.83398 2.23828 3.78399 2.89453 3.12775 4.99451C2.60275 6.96325 2.4715 8.27574 2.4715 8.40699Z",
    fill: "#F2494F"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4715 8.40699C2.4715 8.40699 2.60275 6.832 3.12775 4.99451C3.78399 2.89453 4.83398 2.23828 4.83398 2.23828C4.83398 2.23828 3.78399 2.89453 3.12775 4.86326C2.60275 6.832 2.4715 8.27574 2.4715 8.40699Z",
    fill: "#F2494F"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3387 8.40699C2.3387 8.40699 2.46995 6.70075 2.99494 4.86326C3.65119 2.89453 4.70117 2.23828 4.70117 2.23828C4.70117 2.23828 3.78243 2.89453 2.99494 4.86326C2.6012 6.70075 2.3387 8.27574 2.3387 8.40699Z",
    fill: "#F2494F"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34025 8.40542C2.34025 8.40542 2.4715 6.56794 3.12775 4.73045C3.78399 2.76171 4.83398 2.10547 4.83398 2.10547C4.83398 2.10547 3.91524 2.76171 3.12775 4.73045C2.4715 6.43669 2.34025 8.27417 2.34025 8.40542Z",
    fill: "#F2494F"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20744 8.27418C2.20744 8.27418 2.3387 6.30544 2.99494 4.5992C3.78243 2.63046 4.56992 2.10547 4.70117 2.10547C4.70117 2.10547 3.78243 2.63046 3.12619 4.5992C2.46994 6.43669 2.20744 8.27418 2.20744 8.27418Z",
    fill: "#F2494F"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20783 8.27456C2.20783 8.27456 2.47033 6.17458 2.99533 4.46834C3.78282 2.63085 4.57031 1.97461 4.57031 1.97461C4.57031 1.97461 3.78282 2.49961 2.99533 4.46834C2.33909 6.17458 2.20783 8.27456 2.20783 8.27456Z",
    fill: "#F2494F"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07892 8.27418C2.07892 8.27418 2.34142 6.04294 2.86641 4.46795C3.65391 2.63046 4.44141 2.10547 4.44141 2.10547C4.44141 2.10547 3.65391 2.63046 2.86641 4.46795C2.34142 6.04294 2.07892 8.27418 2.07892 8.27418Z",
    fill: "#F2494F"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94768 8.27456C1.94768 8.27456 2.21017 5.78083 2.86642 4.33709C3.65391 2.49961 4.44141 1.97461 4.44141 1.97461C4.44141 1.97461 3.65391 2.49961 2.86642 4.33709C2.34142 5.91208 1.94768 8.27456 1.94768 8.27456Z",
    fill: "#F2494F"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94768 8.27456C1.94768 8.27456 2.21017 5.64958 2.86642 4.20584C3.78516 2.36836 4.44141 1.97461 4.44141 1.97461C4.44141 1.97461 3.65391 2.49961 2.86642 4.20584C2.21017 5.64958 1.94768 8.27456 1.94768 8.27456Z",
    fill: "#F2494F"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C3.12891 3.54883 2.07891 5.25507 1.81641 8.2738C1.81641 8.2738 2.07891 6.30506 2.34141 5.91131C2.47266 5.25507 2.99766 3.81133 3.12891 3.54883Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C3.12891 3.68008 2.07891 5.25507 1.81641 8.2738C1.81641 8.2738 2.07891 6.30506 2.34141 5.91131C2.47266 5.25507 2.99766 3.81133 3.12891 3.54883Z",
    fill: "#FDE9EA"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C2.99766 3.81133 2.21016 5.25507 1.81641 8.2738C1.81641 8.2738 2.07891 6.43631 2.21016 5.91131C2.47266 5.25507 2.99766 3.81133 3.12891 3.54883Z",
    fill: "#FDD5D6"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C2.99766 3.94258 2.21016 5.25507 1.94767 8.2738C1.94767 8.2738 2.21017 6.43631 2.34142 5.78006C2.60391 5.25507 2.99766 3.81133 3.12891 3.54883Z",
    fill: "#FCC1C3"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C2.86641 4.07382 2.21016 5.25507 1.94767 8.2738C1.94767 8.2738 2.21017 6.43631 2.34142 5.78006C2.60391 5.25507 2.99766 3.81133 3.12891 3.54883Z",
    fill: "#FDAEB0"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C2.86641 4.20507 2.21016 5.25507 1.94767 8.2738C1.94767 8.2738 2.21017 6.56756 2.34142 5.78006C2.60391 5.12382 2.99766 3.81133 3.12891 3.54883Z",
    fill: "#FF999D"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C2.73516 4.33632 2.21016 5.25507 1.94767 8.2738C1.94767 8.2738 2.07892 6.56756 2.34142 5.78006C2.60391 5.12382 2.99766 3.81133 3.12891 3.54883Z",
    fill: "#FA8488"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C2.73516 4.46757 2.34142 5.25507 2.07892 8.2738C2.07892 8.2738 2.21017 6.69881 2.47266 5.78006C2.60391 5.12382 2.99766 3.81133 3.12891 3.54883Z",
    fill: "#F97378"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C2.60391 4.59882 2.34142 5.25507 2.07892 8.2738C2.07892 8.2738 2.21017 6.69881 2.47266 5.78006C2.60391 5.12382 2.99766 3.81133 3.12891 3.54883Z",
    fill: "#F65E63"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 3.54883C2.60391 4.73007 2.34142 5.25507 2.07892 8.2738C2.07892 8.2738 2.21017 6.83006 2.47266 5.78006C2.60391 5.12382 2.99766 3.81133 3.12891 3.54883Z",
    fill: "#F2494F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9942_107848",
    x1: 9.42905,
    y1: 15.893,
    x2: 9.42905,
    y2: 13.1621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0736196,
    stopColor: "#17120E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8344,
    stopColor: "#37302B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9942_107848",
    x1: 9.03518,
    y1: 16.4534,
    x2: 9.03518,
    y2: 11.7401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0736196,
    stopColor: "#17120E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8344,
    stopColor: "#37302B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9942_107848",
    x1: 7.97981,
    y1: 12.8264,
    x2: 9.59312,
    y2: 17.1903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4707,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6735,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8247,
    stopColor: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9496,
    stopColor: "#D8D8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9942_107848",
    x1: 9.67607,
    y1: 16.7412,
    x2: 8.01393,
    y2: 13.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019887,
    stopColor: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0627381,
    stopColor: "#E3E4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1161,
    stopColor: "#D8D8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    stopColor: "#D1D2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    stopColor: "#CFD0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9202,
    stopColor: "#959697"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9942_107848",
    x1: 9.4208,
    y1: 17.1361,
    x2: 8.23535,
    y2: 11.6885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2867,
    stopColor: "#A09E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4523,
    stopColor: "#737171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6101,
    stopColor: "#504E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#373535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#282525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9942_107848",
    x1: 6.48318,
    y1: 12.9938,
    x2: 11.1883,
    y2: 17.3082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429239,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1628,
    stopColor: "#D6D8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2914,
    stopColor: "#C0C2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#B0B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#A7AAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8098,
    stopColor: "#A4A7A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9942_107848",
    x1: 8.50148,
    y1: 17.418,
    x2: 7.41264,
    y2: 16.2807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9942_107848",
    x1: 7.12511,
    y1: 14.2812,
    x2: 7.13311,
    y2: 15.3351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9942_107848",
    x1: 8.96837,
    y1: 12.8194,
    x2: 8.98202,
    y2: 14.6314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9942_107848",
    x1: 10.7429,
    y1: 14.3577,
    x2: 10.7503,
    y2: 15.3461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9942_107848",
    x1: 10.2492,
    y1: 17.2698,
    x2: 9.54613,
    y2: 15.0519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9942_107848",
    x1: 8.35056,
    y1: 15.021,
    x2: 6.91653,
    y2: 13.8009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5656,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8012,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9942_107848",
    x1: 7.49146,
    y1: 15.0613,
    x2: 5.54372,
    y2: 15.4746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9942_107848",
    x1: 8.07612,
    y1: 15.8668,
    x2: 7.38312,
    y2: 17.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9942_107848",
    x1: 8.24281,
    y1: 16.6958,
    x2: 8.07967,
    y2: 17.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9942_107848",
    x1: 9.4347,
    y1: 16.5595,
    x2: 10.156,
    y2: 17.9811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9942_107848",
    x1: 10.1529,
    y1: 16.2213,
    x2: 10.8104,
    y2: 17.5167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9942_107848",
    x1: 10.5166,
    y1: 15.1936,
    x2: 11.7784,
    y2: 14.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9942_107848",
    x1: 10.4256,
    y1: 14.3449,
    x2: 11.1047,
    y2: 13.7002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9942_107848",
    x1: 9.31421,
    y1: 13.9752,
    x2: 9.2453,
    y2: 11.9897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9942_107848",
    x1: 8.6671,
    y1: 13.9402,
    x2: 8.60003,
    y2: 12.0045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9942_107848",
    x1: 8.73066,
    y1: 14.903,
    x2: 10.4877,
    y2: 16.7805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1267,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3611,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6774,
    stopColor: "#98989A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9942_107848",
    x1: 8.26512,
    y1: 14.9995,
    x2: 8.23335,
    y2: 15.4091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9942_107848",
    x1: 8.60216,
    y1: 15.1145,
    x2: 8.22732,
    y2: 15.3065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9942_107848",
    x1: 8.4221,
    y1: 15.2777,
    x2: 8.24004,
    y2: 15.2777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9942_107848",
    x1: 8.30383,
    y1: 15.3241,
    x2: 8.34807,
    y2: 15.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_9942_107848",
    x1: 9.05078,
    y1: 14.362,
    x2: 9.01901,
    y2: 14.7724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_9942_107848",
    x1: 9.2802,
    y1: 14.4805,
    x2: 8.90457,
    y2: 14.6729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_9942_107848",
    x1: 9.09461,
    y1: 14.6215,
    x2: 8.91166,
    y2: 14.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_9942_107848",
    x1: 8.9585,
    y1: 14.6728,
    x2: 9.00273,
    y2: 14.5346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_9942_107848",
    x1: 9.58431,
    y1: 15.043,
    x2: 9.55255,
    y2: 15.4527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_9942_107848",
    x1: 9.94629,
    y1: 15.1954,
    x2: 9.57014,
    y2: 15.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_9942_107848",
    x1: 9.74667,
    y1: 15.3401,
    x2: 9.5637,
    y2: 15.3401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_9942_107848",
    x1: 9.60518,
    y1: 15.3591,
    x2: 9.64942,
    y2: 15.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_9942_107848",
    x1: 9.04946,
    y1: 15.6912,
    x2: 9.0177,
    y2: 16.1012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_9942_107848",
    x1: 9.27312,
    y1: 15.7966,
    x2: 8.89788,
    y2: 15.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_9942_107848",
    x1: 9.09461,
    y1: 15.934,
    x2: 8.91166,
    y2: 15.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_9942_107848",
    x1: 8.95364,
    y1: 16.0001,
    x2: 8.99827,
    y2: 15.8615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_9942_107848",
    x1: 42.7688,
    y1: 16.1633,
    x2: 42.7688,
    y2: 13.4329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0736196,
    stopColor: "#17120E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8344,
    stopColor: "#37302B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_9942_107848",
    x1: 42.375,
    y1: 16.7235,
    x2: 42.375,
    y2: 12.0105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0736196,
    stopColor: "#17120E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8344,
    stopColor: "#37302B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_9942_107848",
    x1: 41.4304,
    y1: 13.0566,
    x2: 43.0435,
    y2: 17.4204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4707,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6735,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8247,
    stopColor: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9496,
    stopColor: "#D8D8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_9942_107848",
    x1: 43.0192,
    y1: 17.0121,
    x2: 41.3569,
    y2: 13.3274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019887,
    stopColor: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0627381,
    stopColor: "#E3E4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1161,
    stopColor: "#D8D8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1909,
    stopColor: "#D1D2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    stopColor: "#CFD0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9202,
    stopColor: "#959697"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_9942_107848",
    x1: 42.764,
    y1: 17.4063,
    x2: 41.5785,
    y2: 11.9582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2867,
    stopColor: "#A09E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4523,
    stopColor: "#737171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6101,
    stopColor: "#504E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#373535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#282525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_9942_107848",
    x1: 39.8281,
    y1: 13.2623,
    x2: 44.5335,
    y2: 17.5769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429239,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1628,
    stopColor: "#D6D8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2914,
    stopColor: "#C0C2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#B0B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#A7AAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8098,
    stopColor: "#A4A7A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_9942_107848",
    x1: 41.8462,
    y1: 17.6867,
    x2: 40.7575,
    y2: 16.5495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_9942_107848",
    x1: 40.4651,
    y1: 14.5517,
    x2: 40.473,
    y2: 15.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_9942_107848",
    x1: 42.3082,
    y1: 13.0899,
    x2: 42.322,
    y2: 14.9013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_9942_107848",
    x1: 44.0828,
    y1: 14.6271,
    x2: 44.0902,
    y2: 15.6158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_9942_107848",
    x1: 43.5916,
    y1: 17.5409,
    x2: 42.8883,
    y2: 15.3228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_9942_107848",
    x1: 41.6682,
    y1: 15.3217,
    x2: 40.2342,
    y2: 14.1013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5656,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8012,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_9942_107848",
    x1: 40.8376,
    y1: 15.3418,
    x2: 38.8893,
    y2: 15.7552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_9942_107848",
    x1: 41.414,
    y1: 16.1346,
    x2: 40.7213,
    y2: 17.5563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_9942_107848",
    x1: 41.5817,
    y1: 16.9651,
    x2: 41.4186,
    y2: 18.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_9942_107848",
    x1: 42.8005,
    y1: 16.8182,
    x2: 43.5221,
    y2: 18.2398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_9942_107848",
    x1: 43.4961,
    y1: 16.4917,
    x2: 44.1538,
    y2: 17.7871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_9942_107848",
    x1: 43.8572,
    y1: 15.4569,
    x2: 45.1188,
    y2: 14.9088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6664,
    stopColor: "#DADADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9784,
    stopColor: "#CECFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_9942_107848",
    x1: 43.7643,
    y1: 14.6095,
    x2: 44.4435,
    y2: 13.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_9942_107848",
    x1: 42.6542,
    y1: 14.245,
    x2: 42.5853,
    y2: 12.2598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_9942_107848",
    x1: 42.0073,
    y1: 14.21,
    x2: 41.94,
    y2: 12.2747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    stopColor: "#ACADAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_9942_107848",
    x1: 42.0634,
    y1: 15.1837,
    x2: 43.8203,
    y2: 17.0611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1267,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3611,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6774,
    stopColor: "#98989A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_9942_107848",
    x1: 41.6029,
    y1: 15.2705,
    x2: 41.5711,
    y2: 15.6801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_9942_107848",
    x1: 41.9527,
    y1: 15.405,
    x2: 41.5787,
    y2: 15.5967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_9942_107848",
    x1: 41.7643,
    y1: 15.5414,
    x2: 41.5827,
    y2: 15.5414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_9942_107848",
    x1: 41.64,
    y1: 15.5921,
    x2: 41.6842,
    y2: 15.4539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_9942_107848",
    x1: 42.3881,
    y1: 14.6341,
    x2: 42.3564,
    y2: 15.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_9942_107848",
    x1: 42.6182,
    y1: 14.7441,
    x2: 42.2436,
    y2: 14.9359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_9942_107848",
    x1: 42.4372,
    y1: 14.8852,
    x2: 42.254,
    y2: 14.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_9942_107848",
    x1: 42.2947,
    y1: 14.9409,
    x2: 42.3389,
    y2: 14.8023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_9942_107848",
    x1: 43.0495,
    y1: 15.3216,
    x2: 43.0179,
    y2: 15.7314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_9942_107848",
    x1: 43.2841,
    y1: 15.4591,
    x2: 42.9086,
    y2: 15.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_9942_107848",
    x1: 43.0881,
    y1: 15.6037,
    x2: 42.9067,
    y2: 15.6037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_9942_107848",
    x1: 42.9414,
    y1: 15.6272,
    x2: 42.9856,
    y2: 15.4889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_9942_107848",
    x1: 42.3868,
    y1: 15.9626,
    x2: 42.3552,
    y2: 16.3722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_9942_107848",
    x1: 42.6249,
    y1: 16.0848,
    x2: 42.2501,
    y2: 16.2768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_9942_107848",
    x1: 42.4372,
    y1: 16.1977,
    x2: 42.254,
    y2: 16.1977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_9942_107848",
    x1: 42.2902,
    y1: 16.2681,
    x2: 42.3341,
    y2: 16.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_9942_107848",
    x1: 52.407,
    y1: 8.46677,
    x2: 1.15276,
    y2: 8.46677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7099,
    stopColor: "#EEEEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_9942_107848",
    x1: 26.7723,
    y1: 4.66949,
    x2: 26.7723,
    y2: 23.4285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4486,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4648,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6106,
    stopColor: "#9F9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7422,
    stopColor: "#6A6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#434141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9447,
    stopColor: "#2C2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_9942_107848",
    x1: 25.8369,
    y1: 0.703984,
    x2: 25.8369,
    y2: 39.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7099,
    stopColor: "#EEEEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_9942_107848",
    x1: 51.3282,
    y1: 14.5575,
    x2: 51.3282,
    y2: 13.8499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_9942_107848",
    x1: 6.15631,
    y1: 0.037004,
    x2: 4.84342,
    y2: 2.7973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8407,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_9942_107848",
    x1: 23.8817,
    y1: -8.81813,
    x2: 14.9902,
    y2: 9.87425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8407,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_9942_107848",
    x1: 21.3129,
    y1: 4.1096,
    x2: 29.8775,
    y2: 28.8774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0971424,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2734,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4327,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5591,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_9942_107848",
    x1: 1.29651,
    y1: 12.781,
    x2: 1.29021,
    y2: 13.1234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2608,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6039,
    stopColor: "#DFDFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8407,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_9942_107848",
    x1: 2.01497,
    y1: 5.01087,
    x2: 1.87086,
    y2: 12.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2608,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6039,
    stopColor: "#DFDFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8407,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_9942_107848",
    x1: 65.0809,
    y1: 4.32852,
    x2: 31.2504,
    y2: 24.1358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0968192,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2015,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3096,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3306,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_9942_107848",
    x1: 57.6733,
    y1: 0.547123,
    x2: 40.93,
    y2: 36.0054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5604,
    stopColor: "#EFEBEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_9942_107848",
    x1: 14.7937,
    y1: 8.69777,
    x2: 13.4276,
    y2: 6.69163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4926,
    stopColor: "#CACACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6653,
    stopColor: "#D9D9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_9942_107848",
    x1: 14.2562,
    y1: 6.09846,
    x2: 14.2562,
    y2: 8.74562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2566,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4781,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_9942_107848",
    x1: 13.9232,
    y1: 6.75292,
    x2: 14.4994,
    y2: 8.42858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2566,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4781,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_9942_107848",
    x1: 13.9142,
    y1: 6.69557,
    x2: 14.6206,
    y2: 9.73031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1106,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2869,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4781,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_9942_107848",
    x1: 13.9855,
    y1: 6.87446,
    x2: 14.5521,
    y2: 9.4203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_9942_107848",
    x1: 14.1539,
    y1: 6.41615,
    x2: 14.1539,
    y2: 8.70328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1106,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2869,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4781,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#BAB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6287,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#908F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#3F3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    stopColor: "#232020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_9942_107848",
    x1: 14.1543,
    y1: 6.43358,
    x2: 14.1543,
    y2: 8.32619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_9942_107848",
    x1: 27.2753,
    y1: 9.50377,
    x2: 25.9098,
    y2: 7.49802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4926,
    stopColor: "#CACACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6653,
    stopColor: "#D9D9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_9942_107848",
    x1: 26.7213,
    y1: 6.92035,
    x2: 26.7213,
    y2: 9.56765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2566,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4781,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_9942_107848",
    x1: 26.4019,
    y1: 7.56851,
    x2: 26.9773,
    y2: 9.24285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2566,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4781,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_9942_107848",
    x1: 26.39,
    y1: 7.51417,
    x2: 27.0966,
    y2: 10.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1106,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2869,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4781,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_9942_107848",
    x1: 26.4367,
    y1: 7.69659,
    x2: 27.0037,
    y2: 10.2436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_9942_107848",
    x1: 26.6227,
    y1: 7.23841,
    x2: 26.6227,
    y2: 9.52479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1106,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2869,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4781,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5443,
    stopColor: "#BAB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6287,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#908F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#6D6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#3F3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    stopColor: "#232020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_9942_107848",
    x1: 26.6883,
    y1: 7.25679,
    x2: 26.6883,
    y2: 9.14755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_9942_107848",
    x1: 23.594,
    y1: -2.21229,
    x2: -0.192032,
    y2: 23.2398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2609,
    stopColor: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8514,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_9942_107848",
    x1: 29.6582,
    y1: 4.00389,
    x2: 41.8844,
    y2: 4.00389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2086,
    stopColor: "#363638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3249,
    stopColor: "#3A3A3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#474749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5793,
    stopColor: "#5C5C5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    stopColor: "#797A7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8444,
    stopColor: "#9E9FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    stopColor: "#ACAEB2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_9942_107848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3386 6.36087) scale(1.21353 1.21353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0896623,
    stopColor: "#555557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_9942_107848",
    x1: 21.6997,
    y1: 6.33464,
    x2: 21.4523,
    y2: 0.0256278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2086,
    stopColor: "#363638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3249,
    stopColor: "#3A3A3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#474749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5793,
    stopColor: "#5C5C5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    stopColor: "#797A7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8444,
    stopColor: "#9E9FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8896,
    stopColor: "#ACAEB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_9942_107848",
    x1: 12.6606,
    y1: 6.44131,
    x2: 12.877,
    y2: 0.874253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0874385,
    stopColor: "#2A2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#3C3A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3685,
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5849,
    stopColor: "#565658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#4C4B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_9942_107848",
    x1: 23.8455,
    y1: 7.67178,
    x2: 24.097,
    y2: 1.20606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0874385,
    stopColor: "#2A2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#3C3A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3685,
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5849,
    stopColor: "#565658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#4C4B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_9942_107848",
    x1: 36.1303,
    y1: 7.76812,
    x2: 36.2515,
    y2: 4.64964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0874385,
    stopColor: "#2A2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#3C3A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3685,
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5849,
    stopColor: "#565658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#4C4B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_9942_107848",
    x1: 49.6058,
    y1: 10.666,
    x2: 49.4726,
    y2: 9.81143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1539,
    stopColor: "#99999B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    stopColor: "#D6D6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7391,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_9942_107848",
    x1: 48.5475,
    y1: 10.1371,
    x2: 48.5147,
    y2: 9.64108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0756559,
    stopColor: "#888889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#9D9D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4903,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_9942_107848",
    x1: 48.5603,
    y1: 9.91287,
    x2: 48.5198,
    y2: 9.30112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0756559,
    stopColor: "#888889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#9D9D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4903,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_9942_107848",
    x1: 49.781,
    y1: 12.1247,
    x2: 49.6496,
    y2: 10.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0756559,
    stopColor: "#888889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#9D9D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3363,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4903,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_9942_107848",
    x1: 49.8716,
    y1: 11.9511,
    x2: 49.8446,
    y2: 11.5433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#888889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3517,
    stopColor: "#9D9D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_9942_107848",
    x1: 50.5037,
    y1: 10.5771,
    x2: 50.8141,
    y2: 11.6317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0927919,
    stopColor: "#888889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2363,
    stopColor: "#9D9D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6014,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_9942_107848",
    x1: 48.8484,
    y1: 11.0285,
    x2: 49.3329,
    y2: 11.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0927919,
    stopColor: "#888889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2363,
    stopColor: "#9D9D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6014,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_9942_107848",
    x1: 48.5601,
    y1: 10.1002,
    x2: 49.1062,
    y2: 10.2301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1124,
    stopColor: "#888889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2863,
    stopColor: "#9D9D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7287,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_9942_107848",
    x1: 49.0443,
    y1: 10.4403,
    x2: 48.6503,
    y2: 9.9293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0315726,
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#A6A6A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3268,
    stopColor: "#C5C5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4714,
    stopColor: "#DCDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#E9E9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7287,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_9942_107848",
    x1: 48.9054,
    y1: 10.3238,
    x2: 49.0377,
    y2: 10.9381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0315726,
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#A6A6A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3268,
    stopColor: "#C5C5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4714,
    stopColor: "#DCDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#E9E9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7287,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_9942_107848",
    x1: 48.6414,
    y1: 10.363,
    x2: 48.7492,
    y2: 10.8624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0315726,
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#A6A6A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3268,
    stopColor: "#C5C5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4714,
    stopColor: "#DCDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#E9E9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7287,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_9942_107848",
    x1: 48.1861,
    y1: 10.3018,
    x2: 48.4927,
    y2: 9.70065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    stopColor: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_9942_107848",
    x1: 48.8887,
    y1: 10.2554,
    x2: 49.2112,
    y2: 9.62269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7443,
    stopColor: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8163,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_9942_107848",
    x1: 49.7357,
    y1: 9.64186,
    x2: 50.0766,
    y2: 10.4859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1294,
    stopColor: "#99999B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4629,
    stopColor: "#D6D6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6216,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_9942_107848",
    x1: 50.7542,
    y1: 10.9377,
    x2: 50.937,
    y2: 11.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1294,
    stopColor: "#99999B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4629,
    stopColor: "#D6D6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6216,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_9942_107848",
    x1: 49.9115,
    y1: 10.5315,
    x2: 49.9285,
    y2: 11.1074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1411,
    stopColor: "#232020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#302D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7157,
    stopColor: "#3D3B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_9942_107848",
    x1: 49.6494,
    y1: 10.1917,
    x2: 49.772,
    y2: 10.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0927919,
    stopColor: "#888889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2363,
    stopColor: "#9D9D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6014,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_9942_107848",
    x1: 50.7422,
    y1: 10.2267,
    x2: 51.2103,
    y2: 11.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0927919,
    stopColor: "#888889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2363,
    stopColor: "#9D9D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4125,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6014,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_9942_107848",
    x1: 50.5314,
    y1: 11.374,
    x2: 50.7707,
    y2: 12.1012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0122699,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    stopColor: "#D5D5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4687,
    stopColor: "#A0A0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    stopColor: "#79797B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#626264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_9942_107848",
    x1: 50.4365,
    y1: 10.5315,
    x2: 51.4726,
    y2: 11.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0122699,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2016,
    stopColor: "#D5D5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4687,
    stopColor: "#A0A0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    stopColor: "#79797B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#626264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_9942_107848",
    x1: 21.8079,
    y1: -1.41273,
    x2: 21.8416,
    y2: 9.11948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2338,
    stopColor: "#ACACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8133,
    stopColor: "#131313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_9942_107848",
    x1: 18.0915,
    y1: -0.206153,
    x2: 18.0915,
    y2: 6.54188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5453,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5609,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7813,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9318,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_9942_107848",
    x1: 12.9255,
    y1: 6.40889,
    x2: 13.1399,
    y2: 0.89814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0874385,
    stopColor: "#2A2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#3C3A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3685,
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5849,
    stopColor: "#565658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#4C4B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_9942_107848",
    x1: 24.1087,
    y1: 7.63566,
    x2: 24.3577,
    y2: 1.23438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0874385,
    stopColor: "#2A2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#3C3A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3685,
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5849,
    stopColor: "#565658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#4C4B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_9942_107848",
    x1: 36.9518,
    y1: 1.72986,
    x2: 34.6001,
    y2: 5.84544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00294313,
    stopColor: "#ECECEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0827463,
    stopColor: "#BABABB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1655,
    stopColor: "#8D8D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2511,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3395,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4314,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5285,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6341,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7642,
    stopColor: "#131313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_9942_107848",
    x1: 36.1321,
    y1: 7.72153,
    x2: 36.2522,
    y2: 4.63442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0874385,
    stopColor: "#2A2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#3C3A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3685,
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5849,
    stopColor: "#565658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#4C4B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_9942_107848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3483 6.32898) scale(1.20093 1.20093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0896623,
    stopColor: "#555557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_9942_107848",
    x1: 33.1602,
    y1: 6.7377,
    x2: 35.7833,
    y2: 6.7377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3631,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_9942_107848",
    x1: 32.9904,
    y1: 10.7921,
    x2: 34.8804,
    y2: 3.27298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7099,
    stopColor: "#EEEEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_9942_107848",
    x1: 35.9593,
    y1: 4.02792,
    x2: 33.1634,
    y2: 9.73976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_9942_107848",
    x1: 35.8696,
    y1: 6.89941,
    x2: 34.1331,
    y2: 8.40878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2103,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4378,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6726,
    stopColor: "#E4E4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_9942_107848",
    x1: 34.5357,
    y1: 7.8931,
    x2: 32.9367,
    y2: 6.38427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_9942_107848",
    x1: 35.5536,
    y1: 6.67471,
    x2: 35.4121,
    y2: 8.67193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3631,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_9942_107848",
    x1: 50.8926,
    y1: 14.4018,
    x2: 51.8177,
    y2: 14.4018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSienna);
export default __webpack_public_path__ + "static/media/sienna.c085a3ca4cbbb31a4f29816a67c8eda6.svg";
export { ForwardRef as ReactComponent };